// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/images/login-back.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/icons/checked.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

nav {
  height: 80px;
  position: relative;
  z-index: 2;
}
nav .nav-wrapper {
  box-shadow: 0px 4px 10px -8px rgba(0, 0, 0, 0.75);
  width: 100%;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
nav .mobile_nav_wrapper {
  display: none;
}
nav .left-menu {
  display: flex;
  align-items: center;
  gap: 8px;
}
nav .ant-avatar {
  background-color: #f6f6f6;
}
nav .right-profile {
  display: flex;
  align-items: center;
}
nav .right-profile .notifications {
  margin-right: 40px;
  cursor: pointer;
}
nav .right-profile .profile {
  display: flex;
  gap: 7px;
  align-items: center;
  min-width: 150px;
}
nav .right-profile .profile .info h3 {
  font-weight: 500;
  font-size: 12px;
}
nav .right-profile .profile .info .pro_account {
  font-family: cursive;
}
nav .right-profile .profile .info span {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 5px;
  border-radius: 4px;
  background-color: #edf8fe;
  color: #517a9a;
  text-transform: uppercase;
  box-sizing: border-box;
  border: 1px solid #32b4fd;
}
nav .right-profile .profile .avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}
nav .right-profile .profile .my_image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
nav .right-profile .drop-down {
  margin-left: 20px;
  cursor: pointer;
}

.my_image_big {
  width: 200px;
  height: 200px;
  border-radius: 5px;
}

@media (max-width: 700px) {
  nav {
    box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.0784313725);
    display: flex;
    align-items: center;
    padding: 16px;
  }
  nav .nav-wrapper {
    display: none;
  }
  nav .mobile_nav_wrapper {
    display: flex;
    width: 100%;
  }
  nav .mobile_nav_wrapper .left-menu {
    width: 100%;
    justify-content: space-between;
  }
}
* {
  font-family: "Inter";
}

.ant-form-item-explain-error {
  position: absolute;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s; /* Smooth transition for background color */
  -webkit-text-fill-color: #333 !important; /* Custom text color */
  -webkit-box-shadow: 0 0 0px 1000px #fff inset; /* Change #fff to match your form's input background color */
}

/* For Firefox */
input:-moz-ui-autofill,
input:-moz-ui-autofill:hover,
input:-moz-ui-autofill:focus,
input:-moz-ui-autofill:active {
  background-color: transparent !important;
}

.ant-layout-sider-trigger {
  position: absolute;
  z-index: 5 !important;
  top: 0;
  background: transparent !important;
  max-width: 30px;
  height: 30px;
  top: 20px;
  left: 20px;
}
.ant-layout-sider-trigger svg {
  display: none;
}

.ant-layout-sider,
.ant-layout-sider-dark,
.ant-layout-sider-has-trigger {
  background-color: transparent !important;
}

.ant-menu {
  padding-bottom: 0;
  background: #fff;
  padding-top: 20px;
  border: none !important;
  padding-bottom: 20px;
}

.ant-layout-sider-children {
  background-color: #fff !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between !important;
  padding-right: 5px;
  padding-left: 5px;
  max-height: calc(100vh - 80px);
  overflow: auto;
}
.ant-layout-sider-children::-webkit-scrollbar {
  display: none;
}

.demo-logo-vertical {
  display: none;
}

.secondary-menu {
  border-top: 1px solid #e2e2e2 !important;
}
.secondary-menu .ant-menu-item-selected {
  background-color: transparent !important;
}
.secondary-menu .ant-menu-item:last-child {
  color: #ED4C5C !important;
}

.ant-layout-sider,
.ant-layout-sider-dark {
  max-width: 240px !important;
  width: 240px !important;
  min-width: 240px !important;
}

.ant-layout-sider-has-trigger {
  padding-bottom: 0 !important;
}

.ant-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.ant-layout-sider-collapsed {
  max-width: 64px !important;
  width: 64px !important;
  min-width: 64px !important;
}
.ant-layout-sider-collapsed .ant-menu-item,
.ant-layout-sider-collapsed .ant-menu-submenu-title {
  padding-left: 11px !important;
  padding-top: 5px;
}

.ant-menu-item-selected {
  background-color: #739BFF !important;
  color: #fff !important;
}

.ant-menu-sub {
  background: #fff !important;
}

.content {
  padding: 20px;
  position: relative;
  height: calc(100vh - 80px);
  overflow: auto;
}
.content::-webkit-scrollbar {
  display: none;
}

.ant-drawer {
  display: none;
}

@media (max-width: 1080px) {
  .menu_desktop {
    display: none;
  }
  .ant-drawer {
    display: block;
  }
  .ant-drawer .ant-drawer-header .ant-drawer-header-title {
    display: flex;
    justify-content: end;
  }
  .ant-drawer .ant-drawer-header .ant-drawer-header-title button {
    margin-right: 0;
  }
}
.login-page {
  height: 100vh;
  width: 100vw;
}
.login-page .login-page-wrapper {
  display: flex;
  height: 100%;
}
.login-page .login-page-wrapper .leftside {
  position: relative;
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.login-page .login-page-wrapper .leftside .header-logo {
  width: 580px;
  height: 100px;
  transform: translateY(-100px);
}
.login-page .login-page-wrapper .leftside .line {
  position: absolute;
  bottom: 0;
  left: 0;
}
.login-page .login-page-wrapper .rightside {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-page .login-page-wrapper .rightside .center {
  max-width: 435px;
  width: 100%;
  display: flex;
  transform: translateY(-50px);
  flex-direction: column;
}
.login-page .login-page-wrapper .rightside .center h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
}
.login-page .login-page-wrapper .rightside .center .ant-form-item-row {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.login-page .login-page-wrapper .rightside .center .single-item {
  margin-top: 40px;
  height: 110px;
  position: relative;
}
.login-page .login-page-wrapper .rightside .center .single-item p {
  font-size: 16px;
  color: #131111;
  margin-bottom: 10px;
}
.login-page .login-page-wrapper .rightside .center .single-item p span {
  color: #ED4C5C;
}
.login-page .login-page-wrapper .rightside .center .single-item input {
  height: 64px;
  width: 100%;
  border-radius: 20px;
  padding-left: 55px;
  font-size: 18px;
  background-color: #fff;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined:hover {
  border-color: #37a141;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined {
  border-color: #1953E9;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined.ant-input-status-warning {
  border-color: #faad14 !important;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined.ant-input-status-error {
  border-color: #ED4C5C !important;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-affix-wrapper {
  height: 64px;
  width: 100%;
  border-radius: 20px;
  padding-left: 55px;
  font-size: 18px;
  padding-right: 20px;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-affix-wrapper input {
  height: 100%;
  padding-left: 0;
}
.login-page .login-page-wrapper .rightside .center .single-item .icon {
  position: absolute;
  z-index: 5;
  left: 20px;
  top: 55px;
}
.login-page .login-page-wrapper .rightside .center .ant-form-item-explain-error {
  margin-top: 10px;
}
.login-page .login-page-wrapper .rightside .center .remember {
  display: flex;
  margin-top: 40px;
  position: static;
  height: 24px;
}
.login-page .login-page-wrapper .rightside .center .remember input {
  width: 24px !important;
  height: 24px !important;
}
.login-page .login-page-wrapper .rightside .center .remember .ant-checkbox-inner {
  width: 24px !important;
  height: 24px !important;
  border-radius: 8px;
  border: 1px solid #9c9c9c;
}
.login-page .login-page-wrapper .rightside .center .remember .ant-checkbox-inner .ant-checkbox-checked {
  border: 1px solid transparent !important;
}
.login-page .login-page-wrapper .rightside .center .remember .ant-checkbox-inner::after {
  width: 8px;
  height: 14px;
}
.login-page .login-page-wrapper .rightside .center button {
  margin-top: 75px;
  width: 100%;
  height: 57px;
  font-size: 18px;
  font-weight: 600;
  background-color: #1953E9;
  border-radius: 20px;
}

@media (max-width: 700px) {
  .login-page {
    overflow: hidden;
    margin-right: auto;
    margin-left: auto;
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100dvw !important;
    max-height: 100dvh !important;
    display: flex;
    justify-content: center;
  }
  .login-page .login-page-wrapper .leftside {
    display: none;
  }
  .login-page .login-page-wrapper .rightside {
    width: 100%;
  }
  .login-page .login-page-wrapper .rightside .center {
    max-width: 100vw;
  }
}
.projects {
  padding: 40px;
  transition: opacity 0.3s ease;
  position: relative;
}
.projects .upper-section {
  display: flex;
  justify-content: space-between;
}
.projects .upper-section .download-btn {
  display: flex;
  gap: 30px;
}
.projects .upper-section .download-btn button {
  border-radius: 20px;
}
.projects .upper-section .download-btn .ant-btn-primary {
  background-color: #1953E9;
}
.projects .upper-section .upper_filter {
  display: flex;
  gap: 20px;
}
.projects .upper-section .upper_filter .ant-select {
  height: 40px;
  width: 180px;
}
.projects .upper-section .upper_filter .ant-select .ant-select-selector {
  border-radius: 20px !important;
  background-color: transparent;
}
.projects .upper-section .search-btn {
  width: 330px;
}
.projects .upper-section .search-btn .ant-btn-default {
  border: none;
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  height: 38px;
  width: 47px;
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 2;
  background-color: transparent;
}
.projects .upper-section .search-btn input {
  border-radius: 20px !important;
  width: 330px;
  height: 40px;
  padding-left: 20px;
  padding-right: 50px;
  background-color: transparent;
}
.projects .upper-section .add-project-btn {
  border: 2px solid #1953E9;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 50px;
  border-radius: 20px;
  height: 44px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.projects .upper-section .add-project-btn span {
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  color: #1953E9;
}
.projects .upper-section .add-project-btn .icon {
  transition: all 0.3s ease;
  color: #1953E9 !important;
}
.projects .upper-section .add-project-btn:hover {
  background-color: #1953E9;
}
.projects .upper-section .add-project-btn:hover .icon {
  color: #fff !important;
}
.projects .upper-section .add-project-btn:hover span {
  color: #fff;
}
.projects .projects-list {
  margin-top: 30px;
}
.projects .projects-list ul {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 40px;
}
.projects .projects-list ul li {
  display: flex;
  flex-direction: column;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  background-color: #fff;
}
.projects .projects-list ul li .item .project-title {
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.projects .projects-list ul li .item .project-title h2 {
  font-size: 28px;
  font-weight: 600;
  color: #1953E9;
  text-transform: uppercase;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.projects .projects-list ul li .item .project-title .icon {
  color: #1953E9 !important;
  width: 20px !important;
  height: 20px !important;
  cursor: pointer;
}
.projects .projects-list ul li .item .project-info {
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  box-shadow: 0px -1px 30px 0px rgba(0, 0, 0, 0.1);
}
.projects .projects-list ul li .item .project-info .info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 23px 12px;
}
.projects .projects-list ul li .item .project-info .info .start-date,
.projects .projects-list ul li .item .project-info .info .completion-date {
  display: flex;
  gap: 3px;
  align-items: center;
}
.projects .projects-list ul li .item .project-info .info .start-date .icon,
.projects .projects-list ul li .item .project-info .info .completion-date .icon {
  width: 14px !important;
  height: 14px !important;
  color: #686666 !important;
}
.projects .projects-list ul li .item .project-info .info .start-date span,
.projects .projects-list ul li .item .project-info .info .completion-date span {
  font-size: 12px;
  font-weight: 400;
  color: #686666;
}
.projects .projects-list ul li .item .project-info .info .status {
  font-size: 14px;
  font-weight: 500;
  color: #686666;
}
.projects .projects-list ul li .item .project-info .proccess {
  height: 22px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.projects .projects-list ul li .item .project-info .proccess .proccess-line {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transition: all 0.3s ease;
  width: 0%;
}
.projects .projects-list ul li .item .project-info .proccess span {
  font-size: 12px;
  font-weight: 600;
  position: relative;
  z-index: 3;
}

.loader {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  left: 0px;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
}

@media (max-width: 1320px) {
  .projects .projects-list ul {
    grid-template-columns: 1fr 1fr;
  }
}
.single-project {
  padding: 15px 80px;
}
.single-project .upper-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.single-project .back-home div {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #999999;
}
.single-project .back-home div .icon {
  transform: rotate(90deg);
  width: 20px !important;
  height: 20px !important;
  margin-right: 5px;
  margin-left: -5px;
}
.single-project .save-btn button {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  padding: 10px 30px !important;
  border-radius: 12px;
  background: #1953E9;
  gap: 5px;
}
.single-project .save-btn button:disabled {
  color: rgba(255, 255, 255, 0.7);
  opacity: 0.7;
}
.single-project .save-btn button .ant-btn-icon {
  margin-right: 0 !important;
}

.main {
  padding-top: 35px;
  display: flex;
  justify-content: space-between;
  gap: 100px;
}
.main .left {
  max-width: 400px;
  width: 100%;
}
.main .left h1 {
  font-size: 36px;
  font-weight: 600;
  color: #131111;
  margin-bottom: 5px;
}
.main .left p {
  font-size: 16px;
  font-weight: 400;
  color: #ACACAC;
  margin-bottom: 10px;
}
.main .left .proccess {
  height: 22px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  overflow: hidden;
}
.main .left .proccess .proccess-line {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transition: all 1.2s ease;
  width: 0%;
  border-radius: 10px;
}
.main .left .proccess span {
  font-size: 12px;
  font-weight: 600;
  position: relative;
  z-index: 3;
}
.main .left .dates {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.main .left .dates .start-date,
.main .left .dates .completion-date {
  display: flex;
  align-items: center;
  gap: 3px;
  color: #686666 !important;
  font-size: 12px;
}
.main .left .dates .start-date .icon,
.main .left .dates .completion-date .icon {
  width: 14px !important;
  height: 14px !important;
}
.main .left .client-info {
  margin-top: 20px;
}
.main .left .client-info label {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}
.main .left .client-info label input {
  border-top: none;
  border-left: none;
  border-right: none;
  padding-left: 0;
  border-bottom: 1px solid #a09f9f;
  border-radius: 0;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  background-color: transparent;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 15px;
  width: 100%;
}
.main .left .client-info label input:disabled {
  color: #777777;
}
.main .left .client-info label input:focus {
  background: transparent;
  outline: none;
  box-shadow: none;
}
.main .left .client-info label textarea {
  margin-top: 15px;
  height: auto !important;
  border-top: none;
  border-left: none;
  border-right: none;
  padding-left: 0;
  border-bottom: 1px solid #a09f9f;
  border-radius: 0;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  background-color: transparent;
  resize: none;
}
.main .left .client-info label textarea:focus {
  background: transparent;
  outline: none;
  box-shadow: none;
}
.main .left .client-info label .ant-input {
  height: auto !important;
}
.main .left .client-info label .ant-input-outlined {
  background-color: transparent;
}
.main .right {
  max-width: 533px;
  width: 100%;
}
.main .right .todo {
  border-radius: 10px;
  overflow: hidden;
  background-color: #fbfbfb;
}
.main .right .todo .top {
  height: 15px;
  transition: all 1.2s ease;
}
.main .right .todo h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
  padding-bottom: 32px;
  border-bottom: 1px solid #dddddd;
  margin-top: 33px;
  padding-left: 20px;
}
.main .right .todo .ant-list-empty-text {
  height: 0px;
}
.main .right .todo .ant-list-empty-text .ant-empty-normal {
  padding: 0 !important;
  display: flex;
  justify-content: center;
}
.main .right .todo .ant-list-empty-text .ant-empty-normal::after {
  content: "Any information left ?";
  position: absolute;
  top: 10px;
}
.main .right .todo .ant-list-empty-text::after {
  display: none;
}
.main .right .todo .ant-list-empty-text .ant-empty-image {
  display: none;
}
.main .right .todo .ant-list-empty-text .ant-empty-description {
  display: none;
}
.main .right .todo .ant-list {
  border: none;
}
.main .right .todo .ant-list-item {
  padding: 0;
  padding-left: 20px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  margin-top: 25px;
  border-bottom: none;
}
.main .right .todo .ant-list-item label {
  max-width: 80%;
}
.main .right .todo .ant-list-item label p {
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  color: #3b3b3b;
  word-wrap: break-word;
}
.main .right .todo .ant-list-item .custom-checkbox {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
}
.main .right .todo .ant-list-item .custom-checkbox input {
  opacity: 0;
  position: absolute;
  width: 100%;
}
.main .right .todo .ant-list-item .custom-checkbox .checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 24px;
  min-width: 24px;
  display: inline-block;
  margin-right: 10px;
  border: 1px solid #777777;
  border-radius: 5px;
  transition: all 0.3s ease;
  background-position: center;
  cursor: pointer;
}
.main .right .todo .ant-list-item .custom-checkbox .checkmark:hover {
  background-color: #fbfafa;
}
.main .right .todo .ant-list-item .custom-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.main .right .todo .ant-list-item .custom-checkbox input:checked + .checkmark {
  background-color: #d0f9d4;
  border: 1px solid #36b151;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
}
.main .right .todo .ant-list-item .icon {
  cursor: pointer;
}
.main .right .todo .ant-list-item li {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main .right .todo .field {
  display: flex;
  margin-top: 25px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top: 1px solid #dddddd;
  padding-left: 10px;
  padding-right: 10px;
  gap: 10px;
}
.main .right .todo .field textarea {
  border: none;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  resize: none;
  height: -moz-fit-content;
  height: fit-content;
  border: 1px solid #d6d6d6;
}
.main .right .todo .field button {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: #131111;
  font-size: 16px;
  border: 1px solid #d6d6d6;
}
.main .right .todo .field button .ant-btn-icon {
  margin-right: 0;
  margin-left: 5px;
}

.delete-pop-up {
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-pop-up .ant-modal-content {
  width: 400px !important;
  top: 0 !important;
  padding: 20px !important;
  border-radius: 20px !important;
}
.delete-pop-up .ant-modal {
  width: 500px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}
.delete-pop-up .ant-modal-root {
  width: 500px !important;
}
.delete-pop-up .ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.projects_log {
  border-radius: 16px;
  padding: 30px 20px;
  background-color: #fff;
}
.projects_log .page-title {
  margin-bottom: 22px;
}
.projects_log .page-title h1 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
}
.projects_log .page-title p {
  font-weight: 400;
  font-size: 20px;
  color: #7A7A7A;
}
.projects_log .upper-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.projects_log .upper-section .left {
  display: flex;
  gap: 20px;
}
.projects_log .upper-section .left .search-btn {
  width: 330px;
}
.projects_log .upper-section .left .search-btn .ant-btn-default {
  border: none;
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  height: 38px;
  width: 47px;
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 2;
  background-color: transparent;
}
.projects_log .upper-section .left .search-btn input {
  border-radius: 20px !important;
  width: 330px;
  height: 40px;
  padding-left: 20px;
  padding-right: 50px;
  background-color: transparent;
}
.projects_log .upper-section .left .select {
  position: relative;
  cursor: pointer;
}
.projects_log .upper-section .left .select .icon {
  width: 16px !important;
  height: 16px !important;
  position: absolute;
  right: 12px;
  top: 12px;
  pointer-events: none;
}
.projects_log .upper-section .left .select .ant-select-selector {
  height: 40px;
  width: 170px;
  border-radius: 20px;
}
.projects_log .upper-section .left .select .ant-select-selector .ant-select-selection-item {
  padding-left: 12px;
}
.projects_log .upper-section .left .select .ant-select-arrow {
  display: none !important;
  opacity: 0 !important;
}
.projects_log .upper-section .download-btn button {
  border: 1px solid #1953E9;
}
.projects_log .table {
  padding-top: 40px;
  position: relative;
}
.projects_log .table .ant-table {
  border-radius: 0px !important;
}
.projects_log .table .ant-table-header {
  border-radius: 0px;
}
.projects_log .table .ant-table-thead {
  border-radius: 0px !important;
}
.projects_log .table .ant-table-thead tr th {
  border-radius: 0px !important;
  font-size: 12px;
  color: #828B96;
  font-weight: 500;
  border-left: 0.5px solid #E8E8E8;
  border-right: 0.5px solid #E8E8E8;
}
.projects_log .table .ant-table-thead tr th:first-child {
  border-left: none !important;
}
.projects_log .table .ant-table-thead tr th:last-child {
  border-right: none !important;
}
.projects_log .table .ant-table-thead tr th::before {
  background: none !important;
}
.projects_log .table .ant-table-row td {
  border: 0.5px solid #E8E8E8 !important;
  font-size: 14px;
  font-weight: 500;
}
.projects_log .table .ant-table-row td:first-child {
  border-left: none !important;
}
.projects_log .table .ant-table-row td:last-child {
  border-right: none !important;
  padding: 0 !important;
  padding-right: 5px !important;
  padding-left: 5px !important;
}
.projects_log .table .ant-table-row td:nth-child(6) {
  padding-left: 0;
  padding-bottom: 0;
  padding: 0;
}
.projects_log .table .ant-table-row td .status {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  font-weight: 400;
  font-size: 10px;
  width: 100px;
  height: 24px;
  margin-right: auto;
  margin-left: auto;
}
.projects_log .table .ant-table-row td .date {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 400;
  margin-right: auto;
  margin-left: auto;
  max-width: 100%;
}
.projects_log .table .ant-table-row td .date .icon {
  width: 16px !important;
  height: 16px !important;
}
.projects_log .table .ant-table-row td .updated-by {
  font-size: 13px;
}
.projects_log .table .ant-table-row td .comment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  padding-left: 10px;
  position: relative;
}
.projects_log .table .ant-table-row td .comment span {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 !important;
  justify-content: space-between;
  gap: 2px;
  width: 100%;
  padding-bottom: 16px !important;
  padding-top: 16px !important;
}
.projects_log .table .ant-table-row td .comment span p {
  white-space: nowrap;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.projects_log .table .ant-table-row td .comment .icon {
  min-width: 14px !important;
  min-height: 14px !important;
  max-width: 14px !important;
  max-height: 14px !important;
  color: rgb(203, 213, 224) !important;
  position: relative;
}
.projects_log .table .ant-table-row td .comment button {
  background: none !important;
  color: #000;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  padding: 0;
}
.projects_log .table .ant-table-row td .comment button div {
  display: none;
}
.projects_log .table .ant-pagination {
  justify-content: start;
  position: relative;
}
.projects_log .table .ant-pagination li:last-child {
  position: absolute;
  right: 0;
}
.projects_log .table .ant-pagination .ant-pagination-next, .projects_log .table .ant-pagination .ant-pagination-prev {
  border: 1px solid #F1F2F4 !important;
}
.projects_log .table .item-amout {
  position: absolute;
  right: 120px;
  bottom: 25px;
  font-size: 12px;
  font-weight: 500;
  color: #687588;
}

.ant-popover {
  max-width: 300px !important;
}

@media (max-width: 1400px) {
  .projects_log .table th {
    padding: 12px !important;
  }
  .projects_log .table td {
    padding: 8px !important;
  }
  .projects_log .table td:nth-child(6) {
    padding-left: 0;
    padding-bottom: 0;
    padding: 0;
  }
  .projects_log .table td .comment {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .projects_log .table td .comment p {
    width: 70px;
  }
}
.employees .upper-section .download-btn {
  display: flex;
  gap: 30px;
}
.employees .upper-section .download-btn button {
  border-radius: 20px;
}
.employees .upper-section .download-btn .ant-btn-primary {
  background-color: #1953E9;
}
.employees .uppercase {
  text-transform: uppercase;
}
.employees .table .ant-table-thead tr th {
  border-left: none !important;
  border-right: none !important;
  font-size: 14px;
  color: #434343;
}
.employees .table .ant-table-thead tr th .salary-column-header {
  display: flex;
  justify-content: space-between;
}
.employees .table .ant-table-thead tr th .salary-column-header .icon {
  cursor: pointer;
  transition: all 0.3s ease;
}
.employees .table .ant-table-row:hover .hide-salary::after {
  background-color: #fafafa !important;
}
.employees .table .ant-table-row td {
  border-left: none !important;
  border-right: none !important;
}
.employees .table .ant-table-row td:nth-child(2) {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td:nth-child(7) {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td:nth-child(8) {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td:nth-child(6) {
  padding-left: 14px !important;
}
.employees .table .ant-table-row td .employee-info {
  display: flex;
  background: none !important;
  position: relative;
}
.employees .table .ant-table-row td .employee-info span {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 !important;
  width: 100%;
}
.employees .table .ant-table-row td .employee-info .employee {
  display: flex;
  align-items: center;
  gap: 10px;
  top: 0;
  width: 100%;
}
.employees .table .ant-table-row td .employee-info .employee .avatar {
  display: flex;
}
.employees .table .ant-table-row td .employee-info .employee .avatar img {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 50%;
}
.employees .table .ant-table-row td .employee-info .employee .personal-info p {
  color: #a0aec0;
  font-size: 10px;
  font-weight: 400;
}
.employees .table .ant-table-row td .employee-info .employee .personal-info h4 {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td .employee-info .icon {
  color: #a0aec0 !important;
}
.employees .table .ant-table-row td .job span {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td .job p {
  font-size: 10px;
  font-weight: 400;
  color: #A0AEC0;
}
.employees .table .ant-table-row td .file .icon {
  color: #ED4C5C !important;
  cursor: pointer;
}
.employees .table .ant-table-row td .salary {
  font-size: 12px;
  font-weight: 400;
  padding: 5px;
  display: flex;
  justify-content: center;
  text-align: center;
  position: relative;
  transition: all 0.3s ease;
}
.employees .table .ant-table-row td .hide-salary {
  transition: all 0.3s ease;
}
.employees .table .ant-table-row td .hide-salary::after {
  content: "*********";
  position: absolute;
  background-color: #fff;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.employees .table .ant-table-row td .hide-salary:hover::after {
  opacity: 0;
}
.employees .table .ant-table-row td .edit {
  display: flex;
  align-items: center;
  gap: 14px;
}
.employees .table .ant-table-row td .edit .icon {
  width: 18px !important;
  cursor: pointer;
}
.employees .table .ant-table-row td .edit .icon:first-child {
  color: #624de3 !important;
}
.employees .table .ant-table-row td .edit .icon:last-child {
  color: #a30d11 !important;
}
.employees .table .total-salary {
  font-weight: bold;
  justify-content: end;
  display: flex;
  gap: 10px;
}
.employees .table .total-salary .amount-wrapper {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
}
.employees .table .total-salary .amount-wrapper .total-salary-amount {
  opacity: 0;
  transition: all 0.3s ease;
  font-weight: normal;
  cursor: pointer;
}
.employees .table .total-salary .amount-wrapper .hide-total-salary {
  position: absolute;
  padding-top: 3px;
  font-weight: normal;
  transition: all 0.3s ease;
  width: 100%;
  cursor: pointer;
  height: 100%;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  left: 0;
  top: 0;
}
.employees .table .total-salary .amount-wrapper:hover {
  opacity: 1;
}
.employees .table .total-salary .amount-wrapper:hover .hide-total-salary {
  opacity: 0;
  pointer-events: none;
}
.employees .table .total-salary .amount-wrapper:hover .total-salary-amount {
  opacity: 1;
}

.pop-over {
  display: flex;
  flex-direction: column;
  font-size: 10px;
  font-weight: 400;
  gap: 5px;
}
.pop-over .email {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  color: #A0AEC0;
}
.pop-over .icon {
  width: 12px !important;
  height: 12px !important;
  cursor: pointer;
}

.modal-backdrop2 {
  width: 100%;
  position: fixed;
  height: 100%;
  z-index: 10000;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3137254902);
}
.modal-backdrop2 .prewiev-modal2 {
  width: 85%;
  height: 85%;
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
}
.modal-backdrop2 .prewiev-modal2 .modal-header {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal-backdrop2 .prewiev-modal2 .modal-header .modal-title {
  width: 80%;
}
.modal-backdrop2 .prewiev-modal2 .modal-header button {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
}
.modal-backdrop2 .prewiev-modal2 .file-box {
  width: 100%;
  height: 100%;
}
.modal-backdrop2 .prewiev-modal2 .file-box .content-image {
  background: #ccc;
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.ant-modal-content {
  padding: 30px 50px 60px 50px !important;
}

.ant-modal {
  height: 600px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}

.ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.download-selected_file {
  font-size: 20px;
  transform: translateX(50px);
  color: #222;
}

.cencel-file-popup {
  cursor: pointer;
}

.form-wrapper .title h1 {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #131111;
}
.form-wrapper .title p {
  font-weight: 400;
  font-size: 14px;
  color: #848282;
}
.form-wrapper .avatar {
  height: 120px;
  width: 120px;
  position: relative;
  margin-top: 25px;
}
.form-wrapper .avatar .icon-wrapper {
  position: absolute;
  cursor: pointer;
  height: 30px;
  width: 30px;
  top: 3px;
  right: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #1953E9;
}
.form-wrapper .avatar .icon-wrapper .icon {
  width: 14px !important;
  height: 14px !important;
  color: #fff !important;
}
.form-wrapper .avatar .avatar-photo {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;
}
.form-wrapper .avatar .avatar-photo .icon {
  width: 57px !important;
  height: 57pc !important;
}
.form-wrapper .input-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 40px;
  row-gap: 33px;
  padding-top: 27px;
  padding-bottom: 30px;
}
.form-wrapper .input-wrapper .single-input-item {
  position: relative;
}
.form-wrapper .input-wrapper .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
}
.form-wrapper .input-wrapper .single-input-item input {
  height: 44px;
}
.form-wrapper .input-wrapper .single-input-item .ant-select {
  height: 44px !important;
  position: relative;
}
.form-wrapper .input-wrapper .single-input-item .ant-picker {
  height: 44px !important;
}
.form-wrapper .input-wrapper .single-input-item .ant-form-item {
  margin-bottom: 0;
}
.form-wrapper .input-wrapper .single-input-item .ant-form-item-has-error .PhoneInput input {
  border-color: #ff4d4f;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput {
  border: none !important;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput input {
  border-radius: 6px;
  outline: none;
  border: 1px solid #d9d9d9;
  padding: 4px 11px;
  font-size: 14px;
  transition: all 0.3s ease;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput input::placeholder {
  color: #bfbfbf;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput input:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput .PhoneInputCountry {
  display: none;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput .PhoneInput--focus {
  border: 1px solid none !important;
}
.form-wrapper .input-wrapper .salary {
  gap: 10px;
  display: flex;
  justify-content: center;
  align-items: end;
}
.form-wrapper .input-wrapper .salary .ant-form-item-control-input-content {
  display: flex !important;
  gap: 10px;
  align-items: center;
}
.form-wrapper .input-wrapper .calendar {
  position: relative;
}
.form-wrapper .input-wrapper .calendar .ant-picker {
  display: flex;
  padding-right: 40px;
}
.form-wrapper .input-wrapper .calendar .ant-picker span {
  display: none;
}
.form-wrapper .input-wrapper .calendar .ant-picker input {
  border: none;
}
.form-wrapper .input-wrapper .calendar .icon {
  position: absolute;
  top: 40px !important;
  z-index: 10;
  right: 10px;
  top: 10px !important;
  pointer-events: none;
}
.form-wrapper .expenses-input-wrapper {
  grid-template-columns: 1fr 1fr 1fr;
}
.form-wrapper .salary {
  display: flex;
  justify-content: center;
}

.small-modal .min-title {
  padding: 20px;
}
.small-modal .min-title h1 {
  font-size: 24px;
  font-weight: 600;
  color: #131111;
}
.small-modal ul {
  padding-left: 20px;
  padding-right: 20px;
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}
.small-modal ul li {
  border-radius: 5px;
  height: 170px;
  background-color: #fdfdfd;
  border: 1px solid #f7f7f7;
}
.small-modal ul li .item-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.small-modal ul li .item-wrapper .file-img {
  margin-top: 20px;
}
.small-modal ul li .item-wrapper .file-img .icon {
  max-width: 85px !important;
  max-height: 113px !important;
  width: 85px !important;
  height: 113px !important;
  color: #eb1f1f !important;
}
.small-modal ul li .item-wrapper .file-name {
  display: flex;
  height: 30px;
  align-items: center;
  padding-bottom: 5px;
  padding-right: 7px;
  padding-left: 7px;
}
.small-modal ul li .item-wrapper .file-name input {
  height: 20px;
  border: none !important;
  outline: none;
  padding-right: 0;
  font-size: 12px;
}
.small-modal ul li .item-wrapper .file-name span {
  font-size: 12px;
  text-align: center;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.small-modal ul li .item-wrapper .file-name .ant-input-outlined {
  border: none;
  box-shadow: none;
  border-radius: 0px;
  padding-right: 2px;
}
.small-modal ul li .item-wrapper .file-name .icon {
  color: #36b151 !important;
  cursor: pointer;
}
.small-modal ul li .item-wrapper .delete {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.small-modal ul li .item-wrapper .delete .icon {
  width: 14px !important;
  height: 14px !important;
}
.small-modal ul .upload {
  max-width: 143px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.small-modal ul .upload label {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}
.small-modal ul .upload label input {
  display: none;
}
.small-modal ul .upload label .plus {
  border: 3px solid #eb1f1f;
  cursor: pointer;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.small-modal ul .upload label .plus span {
  font-size: 10px;
  font-weight: 500;
  color: #131111;
}
.small-modal ul .upload label .plus .icon {
  transform: rotateZ(45deg);
  width: 30px !important;
  height: 30px !important;
  color: #eb1f1f !important;
}

.password {
  height: 44px !important;
}
.password .ant-input-affix-wrapper {
  height: 44px !important;
  width: 100%;
  font-size: 18px;
  display: flex;
}
.password .ant-input-affix-wrapper .ant-input {
  max-height: 34px !important;
  display: flex;
}
.password .ant-input-affix-wrapper input {
  height: 44px !important;
  padding-top: 0 !important;
  padding-left: 0;
  font-size: 14px;
}
.password .ant-input-affix-wrapper input::placeholder {
  font-size: 14px;
}

.min-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.min-modal .ant-modal-content {
  width: 773px !important;
  top: 0 !important;
  padding: 0px !important;
  border-radius: 20px !important;
}
.min-modal .ant-modal {
  width: 773px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}
.min-modal .ant-modal-root {
  width: 773px !important;
}
.min-modal .ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.min-modal .ant-modal-footer {
  padding-bottom: 30px !important;
  padding-right: 30px !important;
}
.min-modal .ant-modal-footer button {
  border-radius: 12px;
}
.min-modal .ant-modal-footer button:last-child {
  background-color: #1953E9;
  color: #fff;
}
.min-modal .form-wrapper .title {
  padding: 30px 30px 20px 30px;
  border-bottom: 1px solid #c2c0c0;
  justify-content: space-between;
}
.min-modal .form-wrapper .title h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
  margin-bottom: 5px;
}
.min-modal .form-wrapper .title p {
  font-size: 14px;
  font-weight: 400;
  color: #848282;
}
.min-modal .form-wrapper .upper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  padding: 30px;
}
.min-modal .form-wrapper .upper .single-item input {
  width: 100%;
  height: 46px !important;
  border-radius: 10px;
  font-size: 16px;
}
.min-modal .form-wrapper .upper .single-item input::placeholder {
  font-size: 16px;
}
.min-modal .form-wrapper .upper .single-item .ant-select {
  width: 100% !important;
  height: 46px !important;
  border-radius: 10px !important;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-selection-item {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-selector {
  border-radius: 10px !important;
  display: flex;
  align-items: center;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-selection-placeholder {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  color: #c2c0c0;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-suffix {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .upper .single-item .ant-picker {
  height: 46px !important;
  border-radius: 10px;
  display: flex;
  padding-left: 40px;
}
.min-modal .form-wrapper .upper .single-item .ant-picker span {
  display: none;
}
.min-modal .form-wrapper .upper .single-item .ant-picker input {
  border: none;
}
.min-modal .form-wrapper .upper .calendar {
  position: relative;
}
.min-modal .form-wrapper .upper .calendar .icon {
  position: absolute;
  top: 40px !important;
  z-index: 100;
  left: 10px;
}
.min-modal .form-wrapper .full-width {
  grid-template-columns: 1fr;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select {
  width: 100% !important;
  height: 30px !important;
  border-radius: 10px !important;
  border: 1px solid red;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-selection-item {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-selector {
  border-radius: 10px !important;
  display: flex;
  align-items: center;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-selection-placeholder {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  color: #c2c0c0;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-suffix {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select-selector {
  border: 1px solid red;
}
.min-modal .form-wrapper .ant-select-selection-overflow {
  height: 40px;
  padding-left: 5px;
}
.min-modal .form-wrapper .columns-2 {
  grid-template-columns: 1fr 1fr 1fr;
}
.min-modal .form-wrapper .textarea {
  padding-left: 30px;
  padding-right: 30px;
}
.min-modal .form-wrapper .textarea textarea {
  border-radius: 10px;
  max-height: 223px;
  height: 300px;
  padding: 10px;
  padding-left: 15px;
  min-height: 100px;
}
.min-modal .form-wrapper .textarea textarea::placeholder {
  font-size: 16px;
}

.small-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.small-modal .ant-modal-content {
  width: 500px !important;
  top: 0 !important;
  padding: 0px !important;
  border-radius: 20px !important;
}
.small-modal .ant-modal {
  width: 500px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}
.small-modal .ant-modal-root {
  width: 500px !important;
}
.small-modal .ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.small-modal .ant-modal-footer {
  padding-bottom: 30px !important;
  padding-right: 30px !important;
}
.small-modal .ant-modal-footer button {
  border-radius: 12px;
}
.small-modal .ant-modal-footer button:last-child {
  background-color: #1953E9;
  color: #fff;
}
.small-modal .form-wrapper .title {
  padding: 30px 30px 20px 30px;
  border-bottom: 1px solid #c2c0c0;
  justify-content: space-between;
}
.small-modal .form-wrapper .title h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
  margin-bottom: 5px;
}
.small-modal .form-wrapper .single-item {
  padding-left: 30px;
  margin-top: 30px;
  max-width: 240px;
}
.small-modal .form-wrapper .single-item p {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #131111;
}
.small-modal .form-wrapper .single-item input {
  width: 100%;
  height: 46px !important;
  border-radius: 10px;
  font-size: 16px;
}
.small-modal .form-wrapper .single-item input::placeholder {
  font-size: 16px;
}
.small-modal .form-wrapper .single-item .ant-switch-checked {
  background: #34c759;
}
.small-modal .form-wrapper .single-item .ant-switch-checked:hover {
  background: #34c759 !important;
}
.small-modal .form-wrapper .integration {
  display: flex !important;
  max-width: 100%;
  padding-right: 30px;
  align-items: center;
  gap: 10px;
}
.small-modal .form-wrapper .integration .percentage-icon {
  border: 1px solid #d9d9d9;
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 20px;
  transform: translateY(3px);
}

.company-wage {
  display: flex;
  gap: 10px;
  align-items: center;
}
.company-wage .percentage-icon {
  border: 1px solid #d9d9d9;
  height: 46px;
  min-width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 20px;
  transform: translateY(3px);
}

.settings-table {
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid transparent;
}
.settings-table .ant-table-thead {
  border-radius: 0px !important;
}
.settings-table .ant-table-thead tr th:last-child {
  display: flex;
  align-items: center;
  justify-content: center;
}
.settings-table .ant-table-thead tr th .percentage {
  width: 100%;
  display: flex;
  justify-content: center;
}
.settings-table .ant-table-thead tr th:first-child {
  padding-left: 20px !important;
}
.settings-table .status {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.settings-table .status span {
  display: flex;
  align-items: center;
  gap: 30px;
}
.settings-table .switch {
  display: flex;
  justify-content: center;
}
.settings-table .ant-switch-checked {
  background: #34c759;
}
.settings-table .ant-switch-checked:hover {
  background: #34c759 !important;
}
.settings-table .ant-table-row td:last-child {
  display: flex;
  align-items: center;
  justify-content: center;
}
.settings-table .ant-table-row td .percentage {
  width: 100%;
  display: flex;
  justify-content: center;
}
.settings-table .ant-table-row td:first-child {
  padding-left: 20px !important;
}
.settings-table .edit .icon {
  color: #624de3 !important;
  cursor: pointer;
}
.settings-table .bottom-side {
  display: flex;
  justify-content: end;
  margin-top: 22px;
  margin-bottom: 23px;
  padding-right: 22px;
}
.settings-table .bottom-side button {
  border-radius: 20px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  background-color: #1953E9;
}
.settings-table .bottom-side button span {
  margin-right: 0 !important;
  margin-left: 5px;
}

.filter-checkbox {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
  margin: 5px;
}
.filter-checkbox input {
  opacity: 0;
  position: absolute;
  width: 100%;
}
.filter-checkbox .checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 24px;
  min-width: 24px;
  display: inline-block;
  margin-right: 10px;
  border: 1px solid #777777;
  border-radius: 5px;
  transition: all 0.3s ease;
  background-position: center;
  cursor: pointer;
}
.filter-checkbox .checkmark:hover {
  background-color: #fbfafa;
}
.filter-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.filter-checkbox input:checked + .checkmark {
  background-color: #d0f9d4;
  border: 1px solid #36b151;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
}

.sales {
  border-radius: 16px;
  background-color: #fff;
  min-height: 100%;
}
.sales .page-title {
  display: flex;
  padding: 30px;
  align-items: center;
  justify-content: space-between;
}
.sales .page-title .title-wrapper h1 {
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 11px;
}
.sales .page-title .title-wrapper p {
  font-size: 20px;
  font-weight: 400;
  color: #7a7a7a;
}
.sales .page-title .calculation-btns {
  display: flex;
  gap: 40px;
  align-items: center;
}
.sales .page-title .calculate-btn {
  display: flex;
  height: 40px;
  align-items: center;
  padding-right: 30px;
  padding-left: 33px;
  border-radius: 20px;
  flex-direction: row-reverse;
  gap: 10px;
  background-color: #1953E9;
}
.sales .page-title .calculate-btn .ant-btn-icon {
  margin-right: 0;
}
.sales .page-title .clear-btn {
  background-color: transparent;
  border: 1px solid #1953E9;
  color: #1953E9;
}
.sales .page-title .clear-btn:hover {
  background-color: transparent;
  color: #1953E9;
}
.sales .form-wrapper .client-info {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  gap: 60px;
  padding: 0 30px 20px 30px;
}
.sales .form-wrapper .client-info .single-input-item {
  max-width: 282px;
  width: 100%;
}
.sales .form-wrapper .client-info .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
}
.sales .form-wrapper .client-info .single-input-item input {
  height: 44px;
}
.sales .form-wrapper .client-info .single-input-item .ant-select {
  height: 44px !important;
  position: relative;
}
.sales .form-wrapper .project-info {
  display: flex;
  gap: 60px;
  padding: 30px 30px 30px 30px;
}
.sales .form-wrapper .project-info .single-input-item {
  max-width: 282px;
  width: 100%;
}
.sales .form-wrapper .project-info .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
}
.sales .form-wrapper .project-info .single-input-item input {
  height: 44px;
}
.sales .form-wrapper .project-info .multiple .ant-select {
  min-height: 44px;
  position: relative;
}
.sales .form-wrapper .project-info .multiple .ant-select .ant-select-selection-overflow-item {
  width: 100%;
}
.sales .form-wrapper .project-info .multiple .ant-select .ant-select-selection-item {
  min-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e3e9f9;
  width: 100%;
}
.sales .form-wrapper .project-info .multiple .ant-select .ant-select-selection-item .ant-select-selection-item-content {
  font-size: 14px;
  font-weight: 400;
}
.sales .form-wrapper .project-info .ant-space-compact {
  height: 48px;
}
.sales .form-wrapper .project-info .twin-input {
  max-width: 408px !important;
  width: 100% !important;
}
.sales .form-wrapper .project-info .twin-input .ant-select {
  width: 100%;
  height: 48px;
  width: 270px;
}
.sales .form-wrapper .project-info .twin-input input {
  height: 48px;
  width: 80px !important;
}
.sales .form-wrapper .project-info .twin-input button {
  height: 48px;
  background-color: #1953E9;
}
.sales .form-wrapper .project-info .twin-input button:disabled {
  color: rgba(255, 255, 255, 0.5);
  background-color: #739BFF;
}
.sales .form-wrapper .project-info .team-list {
  padding-top: 10px;
  width: 100%;
  padding-top: 20px;
}
.sales .form-wrapper .project-info .team-list ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sales .form-wrapper .project-info .team-list ul li {
  border: 1px solid #dcdce4;
  border-radius: 10px;
}
.sales .form-wrapper .project-info .team-list ul li .item {
  display: flex;
  padding: 4px;
  gap: 8px;
  padding-right: 14px;
}
.sales .form-wrapper .project-info .team-list ul li .item .fullname {
  padding: 4px 16px;
  background-color: #e3e9f9;
  width: 100%;
  border-radius: 6px;
}
.sales .form-wrapper .project-info .team-list ul li .item .fullname h4 {
  font-size: 12px;
  font-weight: 400;
}
.sales .form-wrapper .project-info .team-list ul li .item .fullname span {
  font-size: 10px;
  font-weight: 400;
  color: #8e8ea9;
}
.sales .form-wrapper .project-info .team-list ul li .item .duration {
  display: flex;
  align-items: center;
  padding-right: 12px;
  background-color: #e3e9f9;
  border-radius: 6px;
  margin-right: 4px;
  font-size: 12px;
}
.sales .form-wrapper .project-info .team-list ul li .item .duration input {
  border: none;
  font-size: 12px;
  width: 45px !important;
  background-color: transparent;
}
.sales .form-wrapper .project-info .team-list ul li .item .duration input:focus {
  box-shadow: none;
}
.sales .form-wrapper .project-info .team-list ul li .item .anticon {
  cursor: pointer;
}

.small-modal .ant-modal-content {
  position: relative;
  overflow: hidden;
}
.small-modal .ant-modal-content .min-title {
  padding-top: 15px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
}
.small-modal .ant-modal-content .confirm-content {
  padding: 20px 30px 0 30px;
}
.small-modal .ant-modal-content .modal-loader {
  width: 100%;
  background-color: rgb(255, 255, 255);
  height: 100%;
  position: absolute;
  opacity: 1;
  z-index: 9999;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: all 0.3s ease;
}
.small-modal .ant-modal-content .modal-loader .loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
}
.small-modal .ant-modal-content .modal-loader .loader-wrapper span {
  font-size: 32px;
  font-weight: 400;
  color: rgb(122, 122, 122);
}
.small-modal .ant-modal-content .modal-loader .lds-roller,
.small-modal .ant-modal-content .modal-loader .lds-roller div,
.small-modal .ant-modal-content .modal-loader .lds-roller div:after {
  box-sizing: border-box;
}
.small-modal .ant-modal-content .modal-loader .lds-roller {
  display: inline-block;
  position: relative;
  transform: scale(1.5);
  width: 80px;
  height: 80px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7.2px;
  height: 7.2px;
  border-radius: 50%;
  background: #1953E9;
  margin: -3.6px 0 0 -3.6px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(1):after {
  top: 62.62742px;
  left: 62.62742px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(2):after {
  top: 67.71281px;
  left: 56px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(3):after {
  top: 70.90963px;
  left: 48.28221px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(5):after {
  top: 70.90963px;
  left: 31.71779px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(6):after {
  top: 67.71281px;
  left: 24px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(7):after {
  top: 62.62742px;
  left: 17.37258px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12.28719px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.small-modal .ant-modal-content .hide-modal-loader {
  opacity: 0;
  pointer-events: none;
}
.small-modal .result {
  transition: all 0.3s ease;
  padding: 20px 30px;
}
.small-modal .result .result-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.small-modal .result .result-wrapper .item {
  border: 1px solid rgb(243, 243, 243);
  min-width: 185px;
  padding: 0px 20px;
  height: 100px;
  background-color: rgba(240, 240, 240, 0.589);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  gap: 12px;
}
.small-modal .result .result-wrapper .item span {
  display: flex;
  font-size: 14px;
  font-weight: 600;
  color: #8c87a8;
}
.small-modal .result .result-wrapper .item h3 {
  display: flex;
  font-size: 20px;
  font-weight: 600;
  color: #624de3;
}
.small-modal .result .totel {
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(240, 240, 240, 0.589);
}
.small-modal .result .totel p {
  font-size: 18px;
  font-weight: 500;
  color: rgb(19, 17, 17);
}

.finance-dashboard .chart-wrapper {
  width: 100%;
  overflow: hidden;
}
.finance-dashboard .page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.finance-dashboard .page-title .ant-select {
  width: 170px;
  border-radius: 20px !important;
  height: 40px;
}
.finance-dashboard .page-title .ant-select .ant-select-selector {
  border-radius: 20px;
  border: 1px solid #1953E9;
}

.twin_inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.twin_inputs .currency_input .ant-select {
  width: 100% !important;
}

.balance_wrapper {
  margin-top: 20px;
}
.balance_wrapper span {
  color: #1953e9;
}

.down_icon_wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 20px;
}
.down_icon_wrapper .down_icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1953E9;
  color: #fff;
}

.balance-chart-box .page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.balance-chart-box .page-title .action_side {
  display: flex;
  gap: 24px;
}
.balance-chart-box .page-title .action_side .ant-btn {
  display: flex;
  border-radius: 20px;
  background-color: transparent;
  color: #000;
  border: 1px solid #1953E9;
}
.balance-chart-box .page-title .action_side .ant-picker {
  color: #000;
  border-radius: 20px;
  border: 1px solid #1953E9;
  color: #000;
}
.balance-chart-box .page-title .action_side .ant-picker .ant-picker-input input::placeholder {
  color: #000;
}
.balance-chart-box .page-title .action_side .ant-picker .ant-picker-suffix {
  color: #000 !important;
}
.balance-chart-box .chart-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Creates 3 equal columns */
  gap: 50px;
}
.balance-chart-box .chart-wrapper .chart-area {
  display: flex;
  align-items: center;
}
.balance-chart-box .chart-wrapper .chart-area .apexcharts-legend-text {
  text-transform: capitalize;
  transition: color 0.3s ease;
}
.balance-chart-box .chart-wrapper .chart-area .label-lists {
  list-style-type: none;
  text-transform: capitalize;
}

.expenses .page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.designed-sum {
  padding: 21px;
  border-radius: 8px;
  background-color: #739bff;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
}

.expense-type-raw {
  font-weight: 600 !important;
}

.method-raw {
  text-transform: uppercase;
}

.expense-comment {
  height: 40px;
}

.date-filter {
  border: 1px solid #1953E9;
  border-radius: 20px;
}
.date-filter .ant-picker-input {
  width: 90px;
}
.date-filter .ant-picker-suffix {
  color: #000 !important;
}

.single-input-item-payment {
  display: flex;
}

.payment-wrapper .currency .ant-select {
  height: 44px;
}
.payment-wrapper .currency label {
  opacity: 0; /* Set the desired opacity value */
  pointer-events: none;
}
.payment-wrapper .currency label .ant-form-item-required::before {
  content: "ppp";
  color: #fff !important;
}

.message-text-wrapper {
  border: 1px solid #a1a3ab;
  border-radius: 6px;
  padding: 14px;
}

.total-salary .amount-wrapper {
  padding: 10px;
  border-radius: 8px;
  background-color: #739BFF;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.total-salary .amount-wrapper span {
  display: flex;
}

.canban {
  padding: 0 30px 30px 30px;
  height: calc(100% - 160px);
}

.sales-performance-box {
  box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.0784313725);
  margin: 30px;
  margin-bottom: 40px;
  border-radius: 20px;
  padding: 30px;
}
.sales-performance-box .title-wrapper {
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
}

.canban_list_wrapper {
  height: 100%;
}
.canban_list_wrapper .canban_list {
  list-style: none;
  display: flex;
  gap: 20px;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.canban_list_wrapper .canban_list::-webkit-scrollbar {
  display: none;
}
.canban_list_wrapper .canban_list .canban_list_item {
  transition: all 0.3s ease;
  background-color: #fff;
  min-height: 500px;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow-y: auto;
  min-width: 240px;
}
.canban_list_wrapper .canban_list .canban_list_item::-webkit-scrollbar {
  display: none;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info {
  margin-bottom: 10px;
  background-color: #fff;
  z-index: 999;
  position: sticky;
  top: 0;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .column_name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #a4a4a4;
  margin-bottom: 10px;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .column_name h3 {
  font-weight: 600;
  font-size: 14px;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .column_name span {
  font-size: 12px;
  font-weight: 400;
  color: #595959;
  padding: 5px 20px;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .add_card_btn {
  border: 1px solid #a4a4a4;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #a4a4a4;
  padding: 7px 70px;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  width: 100%;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column {
  list-style: none;
  height: -moz-fit-content;
  height: fit-content;
  min-height: calc(100% - 94px);
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item {
  padding: 10px 8px;
  box-shadow: 0px 3px 9px 0px rgba(255, 92, 0, 0.1411764706);
  width: 239px;
  height: 138px;
  border: 1px solid #ff5c00;
  border-radius: 5px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item:hover {
  cursor: grab;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .action {
  display: flex;
  gap: 10px;
  justify-content: end;
  margin-bottom: 10px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .action .trash {
  color: #a30d11 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .action .edit {
  color: #624de3 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw {
  display: flex;
  margin-bottom: 8px;
  gap: 8px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw strong {
  cursor: pointer !important;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw span {
  font-weight: 400;
  font-size: 12px;
  color: #888888;
  width: 70px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw p {
  font-size: 12px;
  font-weight: 400;
}

.dragging-overlay {
  padding: 10px 8px;
  box-shadow: 0px 3px 9px 0px rgba(255, 92, 0, 0.1411764706);
  background-color: #fff;
  transition: all 0.3s ease;
  list-style: none;
  width: 239px;
  height: 138px;
  border: 1px solid #000000;
  border-radius: 5px;
}
.dragging-overlay:hover {
  cursor: grabbing;
}
.dragging-overlay .action {
  display: flex;
  gap: 10px;
  justify-content: end;
  margin-bottom: 10px;
}
.dragging-overlay .action .trash {
  color: #a30d11 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.dragging-overlay .action .edit {
  color: #624de3 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.dragging-overlay .info_raw {
  display: flex;
  margin-bottom: 8px;
  gap: 8px;
}
.dragging-overlay .info_raw span {
  font-weight: 400;
  font-size: 12px;
  color: #888888;
  width: 70px;
}
.dragging-overlay .info_raw p {
  font-size: 12px;
  font-weight: 400;
}

.empty-column-placeholder {
  text-align: center;
  padding-top: 30px;
}

.kanban-board {
  display: flex;
  justify-content: space-around;
  padding: 20px;
  height: 100vh;
}

.column {
  background-color: #e2e4e6;
  border-radius: 8px;
  width: 30%;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.column-title {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
}

.task-list {
  background-color: #f4f5f7;
  border-radius: 4px;
  flex-grow: 1;
  min-height: 100px;
  padding: 8px;
  transition: background-color 0.2s ease;
}

.task {
  background-color: #ffffff;
  border-radius: 2px;
  padding: 8px;
  margin-bottom: 8px;
  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
  transition: background-color 0.2s ease;
}

.canban_mobile {
  display: none;
}

.select_status {
  margin-top: 20px;
}
.select_status h3 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
}
.select_status ul {
  list-style: none;
  display: flex;
  gap: 40px;
}
.select_status ul li {
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.textarea_input {
  width: 100%;
}
.textarea_input .ant-form-item-required {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #131111;
}
.textarea_input .single-input-item .ant-input {
  height: 100px;
}

.card_item {
  padding: 28px;
}
.card_item .column_name {
  padding: 4px 10px;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 6px;
}
.card_item h2 {
  font-size: 32px;
  font-weight: 500;
}
.card_item .date {
  font-size: 14px;
  font-weight: 400;
  color: #404040;
  margin-bottom: 20px;
}
.card_item span {
  font-size: 12px;
  font-weight: 400;
  display: flex;
  margin-bottom: 10px;
}
.card_item span p {
  color: #888888;
  font-size: 12px;
  font-weight: 400;
  width: 100px;
}
.card_item h4 {
  margin-top: 20px;
}
.card_item .description {
  border: 1px solid #a1a3ab;
  border-radius: 6px;
  padding: 14px;
  font-size: 14px;
  font-weight: 400;
  margin-top: 10px;
}
.card_item .agent {
  width: 100%;
  padding-top: 14px;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

@media (max-width: 700px) {
  .canban {
    padding: 0 30px 30px 30px;
    height: calc(100% - 160px);
  }
  .ant-modal-confirm .ant-modal-content {
    width: 310px !important;
  }
  .expenses-modal {
    display: flex;
    justify-content: center;
    max-width: 322px !important;
  }
  .expenses-modal .ant-modal-content {
    padding: 15px !important;
  }
  .expenses-modal .form-wrapper {
    overflow: auto;
    max-width: 322px;
    max-height: calc(100dvh - 150px);
  }
  .expenses-modal .form-wrapper ul {
    overflow: auto;
  }
  .expenses-modal .form-wrapper ul::-webkit-scrollbar {
    display: none;
  }
  .expenses-modal .form-wrapper .expenses-input-wrapper {
    display: grid;
    grid-template-columns: 1fr;
  }
  .expenses-modal .form-wrapper .expenses-input-wrapper .salary .salary-inner {
    width: 100%;
  }
  .sales .page-title {
    padding: 10px;
  }
  .sales .page-title .title-wrapper h1 {
    font-size: 18px;
  }
  .sales .page-title .title-wrapper p {
    font-size: 14px;
  }
  .sales .canban_desktop {
    display: none;
  }
  .ant-select-item-option-content span {
    color: #000 !important;
  }
  .mobile_modal .ant-modal-content {
    width: 322px !important;
  }
  .canban_mobile {
    display: block;
    width: 100%;
    padding-bottom: 50px;
  }
  .canban_mobile .select_status .ant-select-selector {
    border-radius: 10px;
    border: none !important;
  }
  .canban_mobile .select_status .ant-select {
    width: 100%;
    border-radius: 10px;
    height: 46px;
    border: 1px solid #acacac;
  }
  .canban_mobile .add_card_btn {
    padding-top: 16px;
  }
  .canban_mobile .add_card_btn .add_btn_wrapper {
    border: 1px solid #a4a4a4;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    color: #a4a4a4;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  .canban_mobile .canban_items ul {
    list-style: none;
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .canban_mobile .canban_items ul li .item_wrapper {
    border-radius: 5px;
    padding: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: 0px 3px 9px 0px rgba(255, 92, 0, 0.1411764706);
  }
  .canban_mobile .canban_items ul li .item_wrapper .action {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    gap: 5px;
  }
  .canban_mobile .canban_items ul li .item_wrapper .action .edit {
    color: #624de3 !important;
  }
  .canban_mobile .canban_items ul li .item_wrapper .action .trash {
    color: #a30d11 !important;
  }
  .canban_mobile .canban_items ul li .item_wrapper .info_raw {
    display: flex;
  }
  .canban_mobile .canban_items ul li .item_wrapper .info_raw span {
    font-size: 12px;
    color: #888888;
    font-weight: 400;
    min-width: 80px;
  }
  .canban_mobile .canban_items ul li .item_wrapper .info_raw p {
    font-size: 12px;
    font-weight: 400;
  }
  .content {
    padding: 10px;
    background-color: #fff;
  }
  .sales-performance-box {
    box-shadow: none;
    margin: 0px;
    margin-bottom: 40px;
    border-radius: 20px;
    padding: 10px;
  }
  .sales-performance-box .title-wrapper {
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
    flex-direction: column;
    gap: 16px;
  }
  .sales-performance-box .title-wrapper * {
    display: none;
  }
  .sales-performance-box .title-wrapper h2 {
    display: flex;
    font-size: 14px;
  }
}
.task_playground {
  border-radius: 16px;
  padding: 30px 20px;
  background-color: #fff;
  min-height: calc(100dvh - 120px);
}
.task_playground .page-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task_playground .page-heading .page-title {
  margin-bottom: 22px;
}
.task_playground .page-heading .page-title h1 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
}
.task_playground .page-heading .page-title p {
  font-weight: 400;
  font-size: 20px;
  color: #7A7A7A;
}
.task_playground .page-heading .upper-section .ant-btn {
  border-radius: 20px;
  background-color: #1953E9;
}
.task_playground .playground_list {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
}
.task_playground .playground_list .list_item {
  padding: 16px;
  border: 1px solid #ededed;
  border-radius: 12px;
  background-color: #f6f6f6;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.task_playground .playground_list .list_item .up_side {
  display: flex;
  justify-content: space-between;
}
.task_playground .playground_list .list_item .up_side .title {
  font-size: 24px;
  font-weight: 600;
  color: #1953E9;
  cursor: pointer;
  max-width: 290px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.task_playground .playground_list .list_item .up_side .icon {
  cursor: pointer;
}
.task_playground .playground_list .list_item .low_side {
  padding-top: 10px;
  border-top: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task_playground .playground_list .list_item .low_side .author {
  display: flex;
}
.task_playground .playground_list .list_item .low_side .author span {
  display: flex;
  margin-right: 5px;
}
.task_playground .playground_list .list_item .low_side .author p {
  display: flex;
}

.popover_content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.popover_content span {
  display: flex;
  width: 100px;
  cursor: pointer;
}
.popover_content span p {
  font-size: 16px;
  font-weight: 500;
  color: #686666;
}
.popover_content span .icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  color: #686666 !important;
}

.canban_page_wrapper {
  height: calc(100dvh - 120px) !important;
  overflow: hidden;
}

.priority_high {
  color: #dd2f2f !important;
}

.trello_title_wrapper {
  display: flex;
  flex-direction: column;
}

.trello_back_btn {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  width: 100%;
}
.trello_back_btn * {
  color: #7A7A7A !important;
}
.trello_back_btn div {
  display: flex;
  align-items: center;
}
.trello_back_btn div .icon {
  transform: rotateZ(90deg);
}

.priority_medium {
  color: #ff9900 !important;
}

.priority_low {
  color: #1953e9 !important;
}

.trello_column_item {
  border: 1px solid #a4a4a4;
  padding: 16px;
  border-radius: 10px;
}
.trello_column_item:hover {
  cursor: grab;
}
.trello_column_item .item_wrapper .prpject_title h2 {
  font-size: 16px;
  font-weight: 600;
  max-width: 205px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}
.trello_column_item .item_wrapper .priority {
  display: flex;
  align-items: center;
  margin-top: 4px;
  gap: 20px;
  margin-bottom: 12px;
  justify-content: space-between;
}
.trello_column_item .item_wrapper .priority span {
  display: block;
  font-size: 14px;
  color: #54577a;
  max-width: 160px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.trello_column_item .item_wrapper .priority .icon {
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
}
.trello_column_item .item_wrapper .date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.trello_column_item .item_wrapper .date .date_wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.trello_column_item .item_wrapper .date .date_wrapper .icon {
  width: 22px;
  height: 22px;
  color: #00c853 !important;
}
.trello_column_item .item_wrapper .date .action {
  cursor: pointer;
}
.trello_column_item .item_wrapper .members {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.trello_column_item .item_wrapper .members .mine {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 5px;
  border-radius: 4px;
  background-color: #edf8fe;
  color: #517a9a;
  text-transform: uppercase;
  box-sizing: border-box;
  border: 1px solid #32b4fd;
}
.trello_column_item .item_wrapper .creators {
  cursor: pointer !important;
  width: -moz-fit-content;
  width: fit-content;
}

.trello_btn_wrapper {
  height: 70vh;
  align-items: center;
  display: flex;
  padding-left: 20px;
}

.add_column_trello {
  display: flex;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: #1953E9;
  cursor: pointer;
}
.add_column_trello * {
  color: #fff;
}

.status .icon {
  cursor: pointer;
}

.page_title_wrapper_trello {
  width: 100%;
}

.upper_section_trello {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.upper_section_trello .add-btn .ant-btn {
  background-color: #1953E9 !important;
  border-radius: 20px !important;
}

.colors_for_playground {
  display: flex;
  gap: 14px;
  justify-content: space-between;
}
.colors_for_playground span {
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.color_label {
  font-size: 14px;
  display: flex;
  margin-bottom: 14px;
}

.dragging-overlay-trello {
  list-style: none;
  background-color: #fff;
}
.dragging-overlay-trello .item_wrapper:hover {
  cursor: grabbing;
}
.dragging-overlay-trello .item_wrapper .prpject_title h2 {
  font-size: 16px;
  font-weight: 600;
}
.dragging-overlay-trello .item_wrapper .priority {
  display: flex;
  align-items: center;
  margin-top: 4px;
  gap: 20px;
  margin-bottom: 12px;
}
.dragging-overlay-trello .item_wrapper .priority span {
  font-size: 14px;
  color: #54577a;
}
.dragging-overlay-trello .item_wrapper .priority .icon {
  width: 20px;
  height: 20px;
}
.dragging-overlay-trello .item_wrapper .date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.dragging-overlay-trello .item_wrapper .date .date_wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dragging-overlay-trello .item_wrapper .date .date_wrapper .icon {
  width: 22px;
  height: 22px;
}
.dragging-overlay-trello .item_wrapper .date .action .icon {
  cursor: pointer;
}

.file_upload_trello .ant-upload-list {
  display: flex;
  flex-wrap: wrap;
}
.file_upload_trello .ant-upload-list .ant-upload-list-item {
  margin-right: 10px;
}

.multiple_select_trello {
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.multiple_select_trello .ant-select-selector {
  min-height: 44px;
}
.multiple_select_trello .ant-select {
  position: relative;
}
.multiple_select_trello .ant-select .ant-select-selection-item {
  min-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e3e9f9;
}
.multiple_select_trello .ant-select .ant-select-selection-item .ant-select-selection-item-content {
  font-size: 14px;
  font-weight: 400;
}

.small-modal {
  position: relative;
  z-index: 9999999;
}

.ant-popover {
  z-index: 1000;
}

.task_create_modal_wrapper {
  padding: 30px;
  height: 100%;
}
.task_create_modal_wrapper .single-input-item {
  position: relative;
}
.task_create_modal_wrapper .single-input-item .ant-row {
  align-items: start;
  width: 100%;
}
.task_create_modal_wrapper .single-input-item .ant-row .ant-col {
  width: 100%;
}
.task_create_modal_wrapper .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
  text-align: start;
  display: flex;
}
.task_create_modal_wrapper .single-input-item input {
  height: 44px;
  width: 100%;
}
.task_create_modal_wrapper .single-input-item .ant-select {
  height: 44px !important;
  position: relative;
}
.task_create_modal_wrapper .single-input-item .ant-picker {
  height: 44px !important;
}
.task_create_modal_wrapper .single-input-item .ant-form-item {
  margin-bottom: 0;
}
.task_create_modal_wrapper .single-input-item .ant-form-item-has-error .PhoneInput input {
  border-color: #ff4d4f;
}
.task_create_modal_wrapper .single-input-item .PhoneInput {
  border: none !important;
}
.task_create_modal_wrapper .single-input-item .PhoneInput input {
  border-radius: 6px;
  outline: none;
  border: 1px solid #d9d9d9;
  padding: 4px 11px;
  font-size: 14px;
  transition: all 0.3s ease;
}
.task_create_modal_wrapper .single-input-item .PhoneInput input::placeholder {
  color: #bfbfbf;
}
.task_create_modal_wrapper .single-input-item .PhoneInput input:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
}
.task_create_modal_wrapper .single-input-item .PhoneInput .PhoneInputCountry {
  display: none;
}
.task_create_modal_wrapper .single-input-item .PhoneInput .PhoneInput--focus {
  border: 1px solid none !important;
}

.w-full {
  width: 100%;
}

.flex-row {
  display: flex;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/Components/Navbar/_navbar.scss","webpack://./src/styles/global.scss","webpack://./src/Build/_build.scss","webpack://./src/Build/Auth/_auth.scss","webpack://./src/styles/variables.scss","webpack://./src/Build/Pages/Projects/_projects.scss","webpack://./src/Build/Pages/Projects/Single/_single.scss","webpack://./src/Build/Pages/Log/_log.scss","webpack://./src/Build/Pages/Employees/_employees.scss","webpack://./src/Build/Pages/Employees/EmployeeModal/_action.scss","webpack://./src/Build/Pages/Projects/Action/_action.scss","webpack://./src/Build/Pages/Settings/Country/Action/_action.scss","webpack://./src/Build/Pages/Settings/Job/_job.scss","webpack://./src/Build/Pages/Sales/calculator/_sales.scss","webpack://./src/Build/Pages/Finance/Dashboard/_dashboard.scss","webpack://./src/Build/Pages/Finance/Expenses/_expenses.scss","webpack://./src/Build/Pages/Sales/canban/_canban.scss","webpack://./src/Build/Pages/Tasks/_task.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;ACLA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;ADQF;ACPE;EACE,iDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ADSJ;ACPE;EACE,aAAA;ADSJ;ACPE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ADSJ;ACNE;EACE,yBAAA;ADQJ;ACLE;EACE,aAAA;EACA,mBAAA;ADOJ;ACNI;EACE,kBAAA;EACA,eAAA;ADQN;ACNI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;ADQN;ACNQ;EACE,gBAAA;EACA,eAAA;ADQV;ACNQ;EACE,oBAAA;ADQV;ACNQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;ADQV;ACLM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ADOR;ACJM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ADMR;ACHI;EACE,iBAAA;EACA,eAAA;ADKN;;ACDA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;ADIF;;ACDA;EACE;IACE,0DAAA;IAKA,aAAA;IACA,mBAAA;IACA,aAAA;EDAF;ECLE;IACE,aAAA;EDOJ;ECFE;IACE,aAAA;IACA,WAAA;EDIJ;ECHI;IACE,WAAA;IACA,8BAAA;EDKN;AACF;AEtGA;EACI,oBAAA;AFwGJ;;AErGA;EACI,kBAAA;AFwGJ;;AErGA;;;;EAII,yDAAA;EAAA,iDAAA,EAAA,2CAAA;EACA,wCAAA,EAAA,sBAAA;EACA,6CAAA,EAAA,4DAAA;AFwGJ;;AErGA,gBAAA;AACA;;;;EAII,wCAAA;AFwGJ;;AGhIA;EACE,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,kCAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AHmIF;AGlIE;EACE,aAAA;AHoIJ;;AGhIA;;;EAGE,wCAAA;AHmIF;;AGhIA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,oBAAA;AHmIF;;AGjIA;EACE,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;AHoIF;AGnIE;EACE,aAAA;AHqIJ;;AGlIA;EACE,aAAA;AHqIF;;AGnIA;EACE,wCAAA;AHsIF;AGrIE;EACE,wCAAA;AHuIJ;AGpII;EACE,yBAAA;AHsIN;;AGlIA;;EAEE,2BAAA;EACA,uBAAA;EACA,2BAAA;AHqIF;;AGnIA;EACE,4BAAA;AHsIF;;AGnIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AHsIF;;AGnIA;EACE,0BAAA;EACA,sBAAA;EACA,0BAAA;AHsIF;AGrIE;;EAEE,6BAAA;EACA,gBAAA;AHuIJ;;AGpIA;EACE,oCAAA;EACA,sBAAA;AHuIF;;AGpIA;EACE,2BAAA;AHuIF;;AGpIA;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;AHuIF;AGrIE;EACE,aAAA;AHuIJ;;AGnIA;EACE,aAAA;AHsIF;;AGnIA;EACE;IACE,aAAA;EHsIF;EGpIA;IACE,cAAA;EHsIF;EGpII;IACE,aAAA;IACA,oBAAA;EHsIN;EGrIM;IACE,eAAA;EHuIR;AACF;AI5PA;EACE,aAAA;EACA,YAAA;AJ8PF;AI7PE;EACE,aAAA;EACA,YAAA;AJ+PJ;AI9PI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;AJgQN;AI/PM;EACE,YAAA;EACA,aAAA;EACA,6BAAA;AJiQR;AI/PM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AJiQR;AI9PI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJgQN;AI/PM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EACA,sBAAA;AJiQR;AIhQQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AJkQV;AI/PQ;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AJiQV;AI9PQ;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AJgQV;AI/PU;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AJiQZ;AIhQY;EACE,cC5DL;AL8TT;AI9PU;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EAEA,kBAAA;EACA,eAAA;EACA,sBAAA;AJ+PZ;AI5PU;EACE,qBAAA;AJ8PZ;AI3PU;EACE,qBC7EA;AL0UZ;AI3PU;EACE,gCAAA;AJ6PZ;AI1PU;EACE,gCAAA;AJ4PZ;AIzPU;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AJ2PZ;AI1PY;EACE,YAAA;EACA,eAAA;AJ4Pd;AIxPU;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;AJ0PZ;AItPQ;EACE,gBAAA;AJwPV;AIrPQ;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AJuPV;AItPU;EACE,sBAAA;EACA,uBAAA;AJwPZ;AIrPU;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AJuPZ;AItPY;EACE,wCAAA;AJwPd;AItPY;EACE,UAAA;EACA,YAAA;AJwPd;AInPQ;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBC/IE;EDgJF,mBAAA;AJqPV;;AI9OA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,4BAAA;IACA,6BAAA;IACA,aAAA;IACA,uBAAA;EJiPF;EI/OI;IACE,aAAA;EJiPN;EI/OI;IACE,WAAA;EJiPN;EIhPM;IACE,gBAAA;EJkPR;AACF;AMhaA;EACE,aAAA;EACA,6BAAA;EACA,kBAAA;ANkaF;AMjaE;EACE,aAAA;EACA,8BAAA;ANmaJ;AMlaI;EACE,aAAA;EACA,SAAA;ANoaN;AMnaM;EACE,mBAAA;ANqaR;AMnaM;EACE,yBDXI;ALgbZ;AMlaI;EACE,aAAA;EACA,SAAA;ANoaN;AMnaM;EACE,YAAA;EACA,YAAA;ANqaR;AMpaQ;EACE,8BAAA;EACA,6BAAA;ANsaV;AMlaI;EACE,YAAA;ANoaN;AMnaM;EACE,YAAA;EACA,wCAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;ANqaR;AMnaM;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;ANqaR;AMjaI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;ANmaN;AMlaM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cDhEI;ALoeZ;AMlaM;EACE,yBAAA;EACA,yBAAA;ANoaR;AMjaM;EACE,yBDxEI;AL2eZ;AMlaQ;EACE,sBAAA;ANoaV;AMlaQ;EACE,WDrEF;ALyeR;AM9ZE;EACE,gBAAA;ANgaJ;AM/ZI;EACE,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;ANiaN;AMhaM;EAEE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,4BAAA;EACA,sBDxFA;ALyfR;AM/ZU;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ANiaZ;AMhaY;EACE,eAAA;EACA,gBAAA;EACA,cD3GF;EC4GE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ANkad;AMhaY;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;ANkad;AM/ZU;EACE,6BAAA;EACA,4BAAA;EACA,gDAAA;ANiaZ;AMhaY;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;ANkad;AMhac;;EAEE,aAAA;EACA,QAAA;EACA,mBAAA;ANkahB;AMjagB;;EACE,sBAAA;EACA,uBAAA;EACA,yBAAA;ANoalB;AMlagB;;EACE,eAAA;EACA,gBAAA;EACA,cD/IX;ALojBP;AMlac;EACE,eAAA;EACA,gBAAA;EACA,cDrJT;ALyjBP;AMhaY;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;ANkad;AMjac;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,yBAAA;EACA,SAAA;ANmahB;AMjac;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;ANmahB;;AMzZA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,oBAAA;AN2ZF;;AMxZA;EAGM;IACE,8BAAA;ENyZN;AACF;AOtmBA;EACE,kBAAA;APwmBF;AOvmBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;APymBJ;AOtmBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cFNQ;AL8mBd;AOvmBM;EACE,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;APymBR;AOpmBI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBF3BM;EE4BN,QAAA;APsmBN;AOrmBM;EACE,+BAAA;EACA,YAAA;APumBR;AOrmBM;EACE,0BAAA;APumBR;;AOjmBA;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;APomBF;AOnmBE;EACE,gBAAA;EACA,WAAA;APqmBJ;AOnmBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;APqmBN;AOnmBI;EACE,eAAA;EACA,gBAAA;EACA,cFnDQ;EEoDR,mBAAA;APqmBN;AOlmBI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;APomBN;AOnmBM;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;APqmBR;AOnmBM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;APqmBR;AOjmBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;APmmBN;AOlmBM;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;APomBR;AOnmBQ;;EACE,sBAAA;EACA,uBAAA;APsmBV;AOjmBI;EACE,gBAAA;APmmBN;AOlmBM;EACE,eAAA;EACA,gBAAA;EACA,WFtGD;AL0sBP;AOnmBQ;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;APqmBV;AOpmBU;EACE,cAAA;APsmBZ;AOpmBU;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;APsmBZ;AOlmBQ;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EAEA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,YAAA;APmmBV;AOlmBU;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;APomBZ;AOjmBQ;EACE,uBAAA;APmmBV;AOjmBQ;EACE,6BAAA;APmmBV;AO7lBE;EACE,gBAAA;EACA,WAAA;AP+lBJ;AO7lBI;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;AP+lBN;AO9lBM;EACE,YAAA;EACA,yBAAA;APgmBR;AO9lBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;APgmBR;AO9lBM;EACE,WAAA;APgmBR;AO9lBQ;EACE,qBAAA;EACA,aAAA;EACA,uBAAA;APgmBV;AO/lBU;EACE,iCAAA;EACA,kBAAA;EACA,SAAA;APimBZ;AO9lBQ;EACE,aAAA;APgmBV;AO9lBQ;EACE,aAAA;APgmBV;AO9lBQ;EACE,aAAA;APgmBV;AO7lBM;EACE,YAAA;AP+lBR;AO7lBM;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AP+lBR;AO9lBQ;EACE,cAAA;APgmBV;AO/lBU;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;APimBZ;AO5lBQ;EACE,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AP8lBV;AO7lBU;EACE,UAAA;EACA,kBAAA;EACA,WAAA;AP+lBZ;AO5lBU;EACE,kBAAA;EAEA,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;AP6lBZ;AO5lBY;EACE,yBAAA;AP8lBd;AO5lBY;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AP8lBd;AO1lBU;EACE,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AP4lBZ;AOxlBQ;EACE,eAAA;AP0lBV;AOvlBQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;APylBV;AOtlBM;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;APwlBR;AOvlBQ;EACE,YAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,wBAAA;EAAA,mBAAA;EACA,yBAAA;APylBV;AOtlBQ;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;APwlBV;AOvlBU;EACE,eAAA;EACA,gBAAA;APylBZ;;AOjlBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;APolBF;AOnlBE;EACE,uBAAA;EACA,iBAAA;EACA,wBAAA;EACA,8BAAA;APqlBJ;AOllBE;EACE,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;APolBJ;AOjlBE;EACE,uBAAA;APmlBJ;AOjlBE;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;APmlBJ;;AQr7BA;EACI,mBAAA;EACA,kBAAA;EACA,sBHQI;ALg7BR;AQv7BI;EACI,mBAAA;ARy7BR;AQx7BQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AR07BZ;AQx7BQ;EACI,gBAAA;EACA,eAAA;EACA,cHTK;ALm8BjB;AQt7BI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ARw7BR;AQv7BQ;EACI,aAAA;EACA,SAAA;ARy7BZ;AQx7BY;EACI,YAAA;AR07BhB;AQz7BgB;EACI,YAAA;EACA,wCAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AR27BpB;AQz7BgB;EACI,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AR27BpB;AQv7BY;EACI,kBAAA;EACA,eAAA;ARy7BhB;AQx7BgB;EACI,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;AR07BpB;AQv7BgB;EACI,YAAA;EACA,YAAA;EACA,mBAAA;ARy7BpB;AQx7BoB;EACI,kBAAA;AR07BxB;AQl7BgB;EACI,wBAAA;EACA,qBAAA;ARo7BpB;AQ96BY;EACI,yBAAA;ARg7BhB;AQ36BI;EACI,iBAAA;EACA,kBAAA;AR66BR;AQ56BQ;EACI,6BAAA;AR86BZ;AQ56BQ;EACI,kBAAA;AR86BZ;AQ56BQ;EACI,6BAAA;AR86BZ;AQ56BgB;EACI,6BAAA;EACA,eAAA;EACA,cHjGR;EGkGQ,gBAAA;EACA,gCAAA;EACA,iCAAA;AR86BpB;AQ76BoB;EACI,4BAAA;AR+6BxB;AQ56BoB;EACI,6BAAA;AR86BxB;AQ56BoB;EACI,2BAAA;AR86BxB;AQt6BY;EACI,sCAAA;EACA,eAAA;EACA,gBAAA;ARw6BhB;AQv6BgB;EACI,4BAAA;ARy6BpB;AQv6BgB;EACI,6BAAA;EACA,qBAAA;EACA,6BAAA;EACA,4BAAA;ARy6BpB;AQt6BgB;EACI,eAAA;EACA,iBAAA;EACA,UAAA;ARw6BpB;AQr6BgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;ARu6BpB;AQr6BgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,eAAA;ARs6BpB;AQr6BoB;EACI,sBAAA;EACA,uBAAA;ARu6BxB;AQp6BgB;EACI,eAAA;ARs6BpB;AQn6BgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ARq6BpB;AQp6BoB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,+BAAA;EACA,4BAAA;ARs6BxB;AQr6BwB;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;ARu6B5B;AQj6BoB;EACI,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,oCAAA;EACA,kBAAA;ARm6BxB;AQj6BoB;EACI,2BAAA;EACA,WHvMjB;EGwMiB,uBAAA;EACA,2BAAA;EACA,wBAAA;EACA,UAAA;ARm6BxB;AQl6BwB;EACI,aAAA;ARo6B5B;AQ55BQ;EACI,sBAAA;EACA,kBAAA;AR85BZ;AQ55BgB;EACI,kBAAA;EACA,QAAA;AR85BpB;AQ15BY;EACI,oCAAA;AR45BhB;AQx5BQ;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AR05BZ;;AQt5BA;EACI,2BAAA;ARy5BJ;;AQt5BA;EAGY;IACI,wBAAA;ERu5Bd;EQr5BU;IACI,uBAAA;ERu5Bd;EQt5Bc;IACI,eAAA;IACA,iBAAA;IACA,UAAA;ERw5BlB;EQt5Bc;IACI,4BAAA;IACA,6BAAA;ERw5BlB;EQv5BkB;IACI,WAAA;ERy5BtB;AACF;ASvqCI;EACE,aAAA;EACA,SAAA;ATyqCN;ASxqCM;EACE,mBAAA;AT0qCR;ASxqCM;EACE,yBJNI;ALgrCZ;ASrqCE;EACE,yBAAA;ATuqCJ;ASjqCQ;EACE,4BAAA;EACA,6BAAA;EAEA,eAAA;EACA,cAAA;ATkqCV;AShqCU;EACE,aAAA;EACA,8BAAA;ATkqCZ;ASjqCY;EACE,eAAA;EACA,yBAAA;ATmqCd;AS1pCU;EACE,oCAAA;AT4pCZ;ASxpCM;EACE,4BAAA;EACA,6BAAA;AT0pCR;ASxpCQ;EACE,eAAA;EACA,gBAAA;AT0pCV;ASvpCQ;EACE,eAAA;EACA,gBAAA;ATypCV;ASvpCQ;EACE,eAAA;EACA,gBAAA;ATypCV;ASvpCQ;EACE,6BAAA;ATypCV;ASvpCQ;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;ATypCV;ASxpCU;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AT0pCZ;ASxpCU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,MAAA;EACA,WAAA;AT0pCZ;ASzpCY;EACE,aAAA;AT2pCd;AS1pCc;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AT4pChB;ASxpCc;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AT0pChB;ASxpCc;EACE,eAAA;EACA,gBAAA;AT0pChB;ASrpCU;EACE,yBAAA;ATupCZ;ASlpCU;EACE,eAAA;EACA,gBAAA;ATopCZ;ASlpCU;EACE,eAAA;EACA,gBAAA;EACA,cJ9GA;ALkwCZ;AS/oCU;EACE,yBAAA;EACA,eAAA;ATipCZ;AS7oCQ;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AT+oCV;AS5oCQ;EACE,yBAAA;AT8oCV;AS5oCU;EACE,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AT8oCZ;AS3oCY;EACE,UAAA;AT6oCd;ASxoCQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AT0oCV;ASzoCU;EACE,sBAAA;EACA,eAAA;AT2oCZ;AS1oCY;EACE,yBAAA;AT4oCd;AS1oCY;EACE,yBAAA;AT4oCd;ASroCI;EACE,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;ATuoCN;AStoCM;EACE,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;ATwoCR;ASvoCQ;EACE,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ATyoCV;ASvoCQ;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EAEA,uBAAA;EACA,OAAA;EACA,MAAA;ATwoCV;AStoCQ;EACE,UAAA;ATwoCV;ASvoCU;EACE,UAAA;EACA,oBAAA;ATyoCZ;ASvoCU;EACE,UAAA;ATyoCZ;;ASjoCA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;ATooCF;ASnoCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,cJrOQ;AL02CZ;ASnoCE;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;ATqoCJ;;ASjoCA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;ATooCF;ASnoCE;EACE,UAAA;EAEA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ATooCJ;ASnoCI;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ATqoCN;ASpoCM;EACE,UAAA;ATsoCR;ASpoCM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;ATsoCR;ASnoCI;EACE,WAAA;EACA,YAAA;ATqoCN;ASnoCM;EACE,gBAAA;EAEA,WAAA;EACA,YAAA;EACA,gBAAA;ATooCR;;AUr6CA;EAGE,uCAAA;AVs6CF;;AUn6CA;EAEE,wBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,8BAAA;AVo6CF;;AUv5CA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AV05CF;;AUt5CA;EACE,eAAA;EACA,2BAAA;EACA,WAAA;AVy5CF;;AUt5CA;EACE,eAAA;AVy5CF;;AUp5CI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AVu5CN;AUr5CI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AVu5CN;AUn5CE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AVq5CJ;AUp5CI;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBLtEM;AL49CZ;AUr5CM;EACE,sBAAA;EACA,uBAAA;EACA,sBAAA;AVu5CR;AUp5CI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AVs5CN;AUr5CM;EACE,sBAAA;EACA,uBAAA;AVu5CR;AU/4CE;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AVi5CJ;AU54CI;EACE,kBAAA;AV84CN;AU74CM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AV+4CR;AU74CM;EACE,YAAA;AV+4CR;AU54CM;EACE,uBAAA;EACA,kBAAA;AV84CR;AU14CM;EACE,uBAAA;AV44CR;AU14CM;EACE,gBAAA;AV44CR;AUv4CU;EACE,qBAAA;AVy4CZ;AUp4CM;EAEE,uBAAA;AVq4CR;AUp4CQ;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AVs4CV;AUr4CU;EACE,cAAA;AVu4CZ;AUr4CU;EACE,qBAAA;EACA,4CAAA;AVu4CZ;AUp4CQ;EACE,aAAA;AVs4CV;AUp4CQ;EACE,iCAAA;AVs4CV;AUj4CI;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AVm4CN;AUj4CM;EACE,wBAAA;EACA,SAAA;EACA,mBAAA;AVm4CR;AU73CI;EACE,kBAAA;AV+3CN;AU93CM;EACE,aAAA;EACA,mBAAA;AVg4CR;AU/3CQ;EACE,aAAA;AVi4CV;AU/3CQ;EACE,YAAA;AVi4CV;AU73CM;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;AV+3CR;AU13CE;EACE,kCAAA;AV43CJ;AUz3CE;EACE,aAAA;EACA,uBAAA;AV23CJ;;AUt3CE;EACE,aAAA;AVy3CJ;AUx3CI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AV03CN;AUt3CE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;AVw3CJ;AUv3CI;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;AVy3CN;AUx3CM;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AV03CR;AUz3CQ;EACE,gBAAA;AV23CV;AU13CU;EACE,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;AV43CZ;AUz3CQ;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AV23CV;AU13CU;EACE,YAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AV43CZ;AUz3CU;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AV23CZ;AUz3CU;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AV23CZ;AUx3CU;EACE,yBAAA;EACA,eAAA;AV03CZ;AUv3CQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AVy3CV;AUx3CU;EACE,sBAAA;EACA,uBAAA;AV03CZ;AUr3CI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVu3CN;AUr3CM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AVu3CR;AUt3CQ;EACE,aAAA;AVw3CV;AUt3CQ;EACE,yBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AVw3CV;AUv3CU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AVy3CZ;AUv3CU;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AVy3CZ;;AUj3CA;EACE,uBAAA;AVo3CF;AUn3CE;EACE,uBAAA;EACA,WAAA;EAEA,eAAA;EACA,aAAA;AVo3CJ;AUn3CI;EACE,2BAAA;EACA,aAAA;AVq3CN;AUn3CI;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AVq3CN;AUp3CM;EACE,eAAA;AVs3CR;;AW7tDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AXguDF;AW/tDE;EACE,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,8BAAA;AXiuDJ;AW9tDE;EACE,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;AXguDJ;AW7tDE;EACE,uBAAA;AX+tDJ;AW5tDE;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AX8tDJ;AW1tDE;EACE,+BAAA;EACA,8BAAA;AX4tDJ;AW1tDI;EACE,mBAAA;AX4tDN;AW3tDM;EACE,yBNjCI;EMkCJ,WN1BA;ALuvDR;AWvtDI;EACE,4BAAA;EACA,gCAAA;EACA,8BAAA;AXytDN;AWxtDM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AX0tDR;AWxtDM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AX0tDR;AWttDI;EACE,aAAA;EACA,kCAAA;EACA,SAAA;EACA,aAAA;AXwtDN;AWttDQ;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AXwtDV;AWvtDU;EACE,eAAA;AXytDZ;AWttDQ;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AXwtDV;AWttDU;EACE,2BAAA;AXwtDZ;AWttDU;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AXwtDZ;AWttDU;EACE,2BAAA;EACA,4BAAA;EACA,cAAA;AXwtDZ;AWttDU;EACE,2BAAA;AXwtDZ;AWptDQ;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AXstDV;AWptDU;EACE,aAAA;AXstDZ;AWptDU;EACE,YAAA;AXstDZ;AWltDM;EACE,kBAAA;AXotDR;AWntDQ;EACE,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;AXqtDV;AWhtDI;EACE,0BAAA;AXktDN;AW/sDU;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,qBAAA;AXitDZ;AWhtDY;EACE,2BAAA;AXktDd;AWhtDY;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AXktDd;AWhtDY;EACE,2BAAA;EACA,4BAAA;EACA,cAAA;AXktDd;AWhtDY;EACE,2BAAA;AXktDd;AW9sDU;EACE,qBAAA;AXgtDZ;AWvsDI;EACE,YAAA;EACA,iBAAA;AXysDN;AWtsDI;EACE,kCAAA;AXwsDN;AWtsDI;EACE,kBAAA;EACA,mBAAA;AXwsDN;AWvsDM;EACE,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AXysDR;AWxsDQ;EACE,eAAA;AX0sDV;;AY73DA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AZg4DF;AY/3DE;EACE,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,8BAAA;AZi4DJ;AY93DE;EACE,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;AZg4DJ;AY73DE;EACE,uBAAA;AZ+3DJ;AY53DE;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AZ83DJ;AY13DE;EACE,+BAAA;EACA,8BAAA;AZ43DJ;AY13DI;EACE,mBAAA;AZ43DN;AY33DM;EACE,yBPjCI;EOkCJ,WP1BA;ALu5DR;AYv3DI;EACE,4BAAA;EACA,gCAAA;EACA,8BAAA;AZy3DN;AYx3DM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AZ03DR;AYt3DI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AZw3DN;AYv3DM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AZy3DR;AYv3DM;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AZy3DR;AYx3DQ;EACE,eAAA;AZ03DV;AYt3DM;EACE,mBAAA;AZw3DR;AYt3DM;EACE,8BAAA;AZw3DR;AYr3DI;EACE,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AZu3DN;AYt3DM;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AZw3DR;;AYl3DA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AZq3DF;AYp3DE;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AZs3DJ;;Aa1+DA;EACE,sBRUM;EQTN,mBAAA;EACA,gBAAA;EACA,6BAAA;Ab6+DF;Aa5+DE;EACE,6BAAA;Ab8+DJ;Aa3+DQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;Ab6+DV;Aa3+DQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;Ab6+DV;Aat+DQ;EACE,6BAAA;Abw+DV;Aal+DE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;Abo+DJ;Aan+DI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;Abq+DN;Aaj+DE;EACE,aAAA;EACA,uBAAA;Abm+DJ;Aaj+DE;EACE,mBAAA;Abm+DJ;Aaj+DE;EACE,8BAAA;Abm+DJ;Aa/9DM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;Abi+DR;Aa/9DM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;Abi+DR;Aa19DM;EACE,6BAAA;Ab49DR;Aat9DI;EACE,yBAAA;EACA,eAAA;Abw9DN;Aaj9DE;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;Abm9DJ;Aal9DI;EACE,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBR9FM;ALkjEZ;Aan9DM;EACE,0BAAA;EACA,gBAAA;Abq9DR;;Aa/8DA;EACE,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;Abk9DF;Aaj9DE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;Abm9DJ;Aah9DE;EACE,kBAAA;EAEA,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;Abi9DJ;Aah9DI;EACE,yBAAA;Abk9DN;Aah9DI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;Abk9DN;Aa98DE;EACE,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;Abg9DJ;;AcrmEA;EACE,mBAAA;EACA,sBTSM;ESRN,gBAAA;AdwmEF;ActmEE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AdwmEJ;ActmEM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AdwmER;ActmEM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AdwmER;AcrmEI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AdumEN;AcrmEI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,yBTjCM;ALwoEZ;ActmEM;EACE,eAAA;AdwmER;AcpmEI;EACE,6BAAA;EACA,yBAAA;EACA,cT1CM;ALgpEZ;AcrmEM;EACE,6BAAA;EACA,cT7CI;ALopEZ;AcjmEI;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,yBAAA;AdmmEN;AclmEM;EACE,gBAAA;EACA,WAAA;AdomER;AcnmEQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AdqmEV;AcnmEQ;EACE,YAAA;AdqmEV;AclmEQ;EACE,uBAAA;EACA,kBAAA;AdomEV;AchmEI;EACE,aAAA;EACA,SAAA;EACA,4BAAA;AdkmEN;AcjmEM;EACE,gBAAA;EACA,WAAA;AdmmER;AclmEQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AdomEV;AclmEQ;EACE,YAAA;AdomEV;AchmEQ;EACE,gBAAA;EACA,kBAAA;AdkmEV;AcjmEU;EACE,WAAA;AdmmEZ;AcjmEU;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AdmmEZ;AclmEY;EACE,eAAA;EACA,gBAAA;AdomEd;Ac/lEM;EACE,YAAA;AdimER;Ac/lEM;EAEE,2BAAA;EACA,sBAAA;AdgmER;Ac/lEQ;EACE,WAAA;EACA,YAAA;EACA,YAAA;AdimEV;Ac/lEQ;EACE,YAAA;EACA,sBAAA;AdimEV;Ac/lEQ;EACE,YAAA;EACA,yBTjIE;ALkuEZ;AchmEU;EACE,+BAAA;EACA,yBTrIF;ALuuEV;Ac9lEM;EACE,iBAAA;EAEA,WAAA;EACA,iBAAA;Ad+lER;Ac9lEQ;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AdgmEV;Ac/lEU;EACE,yBAAA;EACA,mBAAA;AdimEZ;AchmEY;EACE,aAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;AdkmEd;AcjmEc;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AdmmEhB;AclmEgB;EACE,eAAA;EACA,gBAAA;AdomElB;AclmEgB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AdomElB;AcjmEc;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AdmmEhB;AclmEgB;EACE,YAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;AdomElB;AcnmEkB;EACE,gBAAA;AdqmEpB;AcjmEc;EACE,eAAA;AdmmEhB;;AcxlEE;EACE,kBAAA;EACA,gBAAA;Ad2lEJ;Ac1lEI;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;Ad4lEN;Ac1lEI;EACE,yBAAA;Ad4lEN;Ac1lEI;EACE,WAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;Ad4lEN;Ac1lEM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;Ad4lER;Ac3lEQ;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;Ad6lEV;AczlEM;;;EAGE,sBAAA;Ad2lER;AczlEM;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;Ad2lER;AczlEM;EACE,gEAAA;EACA,2BAAA;Ad2lER;AczlEM;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBTnQI;ESoQJ,yBAAA;Ad2lER;AczlEM;EACE,wBAAA;Ad2lER;AczlEM;EACE,eAAA;EACA,gBAAA;Ad2lER;AczlEM;EACE,wBAAA;Ad2lER;AczlEM;EACE,eAAA;EACA,UAAA;Ad2lER;AczlEM;EACE,wBAAA;Ad2lER;AczlEM;EACE,eAAA;EACA,gBAAA;Ad2lER;AczlEM;EACE,wBAAA;Ad2lER;AczlEM;EACE,SAAA;EACA,UAAA;Ad2lER;AczlEM;EACE,uBAAA;Ad2lER;AczlEM;EACE,eAAA;EACA,gBAAA;Ad2lER;AczlEM;EACE,wBAAA;Ad2lER;AczlEM;EACE,eAAA;EACA,UAAA;Ad2lER;AczlEM;EACE,wBAAA;Ad2lER;AczlEM;EACE,eAAA;EACA,gBAAA;Ad2lER;AczlEM;EACE,wBAAA;Ad2lER;AczlEM;EACE,SAAA;EACA,gBAAA;Ad2lER;AczlEM;EACE;IACE,uBAAA;Ed2lER;EczlEM;IACE,yBAAA;Ed2lER;AACF;AcvlEI;EACE,UAAA;EACA,oBAAA;AdylEN;ActlEE;EAEE,yBAAA;EACA,kBAAA;AdulEJ;AcrlEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AdulEN;ActlEM;EACE,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,SAAA;AdulER;ActlEQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AdwlEV;ActlEQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AdwlEV;AcplEI;EACE,aAAA;EACA,mBAAA;EACA,4CAAA;AdslEN;AcrlEM;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AdulER;;Aej9EE;EACE,WAAA;EACA,gBAAA;Afo9EJ;Ael9EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;Afo9EJ;Ael9EI;EACE,YAAA;EACA,8BAAA;EACA,YAAA;Afo9EN;Aen9EM;EACE,mBAAA;EACA,yBAAA;Afq9ER;;Ae/8EA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;Afk9EF;Aeh9EI;EACE,sBAAA;Afk9EN;;Ae98EA;EACE,gBAAA;Afi9EF;Ae/8EE;EACE,cAAA;Afi9EJ;;Ae78EA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;Afg9EF;Ae/8EE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBVnDQ;EUoDR,WV5CI;AL6/ER;;Ae58EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;Af+8EJ;Ae78EI;EACE,aAAA;EACA,SAAA;Af+8EN;Ae98EM;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WV5DD;EU6DC,yBAAA;Afg9ER;Ae78EM;EACE,WVjED;EUkEC,mBAAA;EACA,yBAAA;EACA,WVpED;ALmhFP;Ae58EY;EACE,WVxEP;ALshFP;Ae18EQ;EACE,sBAAA;Af48EV;Aev8EE;EACE,aAAA;EACA,qCAAA,EAAA,4BAAA;EACA,SAAA;Afy8EJ;Aex8EI;EACE,aAAA;EACA,mBAAA;Af08EN;Aex8EM;EACE,0BAAA;EACA,2BAAA;Af08ER;Aev8EM;EACE,qBAAA;EACA,0BAAA;Afy8ER;;AgBrjFE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AhBwjFJ;;AgBpjFA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,WXHM;AL0jFR;;AgBrjFA;EACE,2BAAA;AhBwjFF;;AgBtjFA;EACE,yBAAA;AhByjFF;;AgBtjFA;EACE,YAAA;AhByjFF;;AgBtjFA;EACE,yBAAA;EACA,mBAAA;AhByjFF;AgBxjFE;EACE,WAAA;AhB0jFJ;AgBxjFE;EACE,sBAAA;AhB0jFJ;;AgBtjFA;EACE,aAAA;AhByjFF;;AgBpjFI;EACE,YAAA;AhBujFN;AgBrjFI;EACE,UAAA,EAAA,kCAAA;EACA,oBAAA;AhBujFN;AgBrjFM;EACE,cAAA;EACA,sBAAA;AhBujFR;;AgBjjFA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AhBojFF;;AgBhjFE;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AhBmjFJ;AgBljFI;EACE,aAAA;AhBojFN;;AiB/nFA;EACE,yBAAA;EACA,0BAAA;AjBkoFF;;AiB/nFA;EACE,0DAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AjBkoFF;AiBjoFE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;AjBmoFJ;;AiB/nFA;EACE,YAAA;AjBkoFF;AiBjoFE;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EAIA,cAAA;AjBgoFJ;AiBnoFI;EACE,aAAA;AjBqoFN;AiBloFI;EACE,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AjBooFN;AiBnoFM;EACE,aAAA;AjBqoFR;AiBnoFM;EACE,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;AjBqoFR;AiBpoFQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AjBsoFV;AiBroFU;EACE,gBAAA;EACA,eAAA;AjBuoFZ;AiBroFU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AjBuoFZ;AiBpoFQ;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;AjBsoFV;AiBloFM;EACE,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBooFR;AiBnoFQ;EACE,iBAAA;EACA,0DAAA;EAEA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AjBooFV;AiBnoFU;EACE,YAAA;AjBqoFZ;AiBloFU;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;AjBooFZ;AiBloFY;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AjBooFd;AiBloFY;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AjBooFd;AiBjoFU;EACE,aAAA;EACA,kBAAA;EACA,QAAA;AjBmoFZ;AiBloFY;EACE,0BAAA;AjBooFd;AiBloFY;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AjBooFd;AiBloFY;EACE,eAAA;EACA,gBAAA;AjBooFd;;AiB3nFA;EACE,iBAAA;EACA,0DAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AjB8nFF;AiB7nFE;EACE,gBAAA;AjB+nFJ;AiB7nFE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;AjB+nFJ;AiB7nFI;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AjB+nFN;AiB7nFI;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AjB+nFN;AiB3nFE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;AjB6nFJ;AiB3nFI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AjB6nFN;AiB3nFI;EACE,eAAA;EACA,gBAAA;AjB6nFN;;AiBxnFA;EACE,kBAAA;EACA,iBAAA;AjB2nFF;;AiBtnFA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,aAAA;AjBynFF;;AiBtnFA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AjBynFF;;AiBtnFA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AjBynFF;;AiBtnFA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sCAAA;AjBynFF;;AiBtnFA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,sCAAA;AjBynFF;;AiBtnFA;EACE,aAAA;AjBynFF;;AiBtnFA;EACE,gBAAA;AjBynFF;AiBxnFE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AjB0nFJ;AiBxnFE;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AjB0nFJ;AiBznFI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AjB2nFN;;AiBtnFA;EACE,WAAA;AjBynFF;AiBxnFE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;AjB0nFJ;AiBvnFI;EACE,aAAA;AjBynFN;;AiBpnFA;EACE,aAAA;AjBunFF;AiBtnFE;EACE,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AjBwnFJ;AiBtnFE;EACE,eAAA;EACA,gBAAA;AjBwnFJ;AiBtnFE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AjBwnFJ;AiBtnFE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AjBwnFJ;AiBvnFI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AjBynFN;AiBtnFE;EACE,gBAAA;AjBwnFJ;AiBtnFE;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjBwnFJ;AiBtnFE;EACE,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;AjBwnFJ;;AiBpnFA;EACE;IACE,yBAAA;IACA,0BAAA;EjBunFF;EiBnnFE;IACE,uBAAA;EjBqnFJ;EiBjnFA;IACE,aAAA;IACA,uBAAA;IACA,2BAAA;EjBmnFF;EiBlnFE;IACE,wBAAA;EjBonFJ;EiBlnFE;IACE,cAAA;IACA,gBAAA;IACA,gCAAA;EjBonFJ;EiBlnFI;IACE,cAAA;EjBonFN;EiBnnFM;IACE,aAAA;EjBqnFR;EiBlnFI;IACE,aAAA;IACA,0BAAA;EjBonFN;EiBlnFQ;IACE,WAAA;EjBonFV;EiB5mFE;IACE,aAAA;EjB8mFJ;EiB5mFM;IACE,eAAA;EjB8mFR;EiB5mFM;IACE,eAAA;EjB8mFR;EiB1mFE;IACE,aAAA;EjB4mFJ;EiBvmFE;IACE,sBAAA;EjBymFJ;EiBrmFE;IACE,uBAAA;EjBumFJ;EiBnmFA;IACE,cAAA;IACA,WAAA;IACA,oBAAA;EjBqmFF;EiBlmFI;IACE,mBAAA;IACA,uBAAA;EjBomFN;EiBlmFI;IACE,WAAA;IACA,mBAAA;IACA,YAAA;IAEA,yBAAA;EjBmmFN;EiB/lFE;IACE,iBAAA;EjBimFJ;EiBhmFI;IACE,yBAAA;IACA,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,QAAA;EjBkmFN;EiB9lFI;IACE,gBAAA;IACA,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EjBgmFN;EiB9lFQ;IACE,kBAAA;IACA,aAAA;IACA,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IACA,0DAAA;EjBgmFV;EiB9lFU;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,aAAA;IACA,QAAA;EjBgmFZ;EiB/lFY;IACE,yBAAA;EjBimFd;EiB/lFY;IACE,yBAAA;EjBimFd;EiB7lFU;IACE,aAAA;EjB+lFZ;EiB7lFY;IACE,eAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;EjB+lFd;EiB7lFY;IACE,eAAA;IACA,gBAAA;EjB+lFd;EiBtlFA;IACE,aAAA;IACA,sBAAA;EjBwlFF;EiBrlFA;IACE,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;EjBulFF;EiBtlFE;IACE,aAAA;IACA,8BAAA;IACA,oBAAA;IACA,sBAAA;IACA,SAAA;EjBwlFJ;EiBvlFI;IACE,aAAA;EjBylFN;EiBvlFI;IACE,aAAA;IACA,eAAA;EjBylFN;AACF;AkBtlGA;EACE,mBAAA;EACA,kBAAA;EACA,sBbQM;EaPN,gCAAA;AlBwlGF;AkBvlGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AlBylGJ;AkBxlGI;EACE,mBAAA;AlB0lGN;AkBzlGM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AlB2lGR;AkBzlGM;EACE,gBAAA;EACA,eAAA;EACA,cbdS;ALymGjB;AkBvlGM;EACE,mBAAA;EACA,yBbtBI;AL+mGZ;AkBplGE;EACE,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;AlBslGJ;AkBrlGI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AlBulGN;AkBtlGM;EACE,aAAA;EACA,8BAAA;AlBwlGR;AkBvlGQ;EACE,eAAA;EACA,gBAAA;EACA,cb/CE;EagDF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlBylGV;AkBvlGQ;EACE,eAAA;AlBylGV;AkBtlGM;EACE,iBAAA;EACA,6BAAA;EAWA,aAAA;EACA,8BAAA;EACA,mBAAA;AlB8kGR;AkB1lGQ;EACE,aAAA;AlB4lGV;AkB3lGU;EACE,aAAA;EACA,iBAAA;AlB6lGZ;AkB3lGU;EACE,aAAA;AlB6lGZ;;AkBllGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AlBqlGF;AkBplGE;EACE,aAAA;EACA,YAAA;EACA,eAAA;AlBslGJ;AkBrlGI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AlBulGN;AkBrlGI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AlBulGN;;AkBllGA;EACE,uCAAA;EACA,gBAAA;AlBqlGF;;AkBllGA;EACE,yBAAA;AlBqlGF;;AkBnlGA;EACE,aAAA;EACA,sBAAA;AlBslGF;;AkBplGA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AlBulGF;AkBtlGE;EACE,yBAAA;AlBwlGJ;AkBtlGE;EACE,aAAA;EACA,mBAAA;AlBwlGJ;AkBvlGI;EACE,yBAAA;AlBylGN;;AkBplGA;EACE,yBAAA;AlBulGF;;AkBrlGA;EACE,yBAAA;AlBwlGF;;AkBrlGA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AlBwlGF;AkBvlGE;EACE,YAAA;AlBylGJ;AkBplGM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AlBslGR;AkBnlGI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AlBqlGN;AkBplGM;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlBslGR;AkBplGM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AlBslGR;AkBnlGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AlBqlGN;AkBplGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AlBslGR;AkBrlGQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AlBulGV;AkBnlGM;EACE,eAAA;AlBqlGR;AkBllGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AlBolGN;AkBnlGM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;AlBqlGR;AkBllGI;EACE,0BAAA;EACA,uBAAA;EAAA,kBAAA;AlBolGN;;AkBhlGA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AlBmlGF;;AkBjlGA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBb3OU;Ea4OV,eAAA;AlBolGF;AkBnlGE;EACE,WbtOI;AL2zGR;;AkBhlGE;EACE,eAAA;AlBmlGJ;;AkBhlGA;EACE,WAAA;AlBmlGF;;AkBjlGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AlBolGF;AkBllGI;EACE,oCAAA;EACA,8BAAA;AlBolGN;;AkB/kGA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AlBklGF;AkBhlGE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AlBklGJ;;AkB/kGA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AlBklGF;;AkBhlGA;EACE,gBAAA;EACA,sBAAA;AlBmlGF;AkBhlGI;EACE,gBAAA;AlBklGN;AkB/kGM;EACE,eAAA;EACA,gBAAA;AlBilGR;AkB9kGI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AlBglGN;AkB/kGM;EACE,eAAA;EACA,cAAA;AlBilGR;AkB/kGM;EACE,WAAA;EACA,YAAA;AlBilGR;AkB9kGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AlBglGN;AkB/kGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AlBilGR;AkBhlGQ;EACE,WAAA;EACA,YAAA;AlBklGV;AkB9kGQ;EACE,eAAA;AlBglGV;;AkBxkGE;EACE,aAAA;EACA,eAAA;AlB2kGJ;AkB1kGI;EACE,kBAAA;AlB4kGN;;AkBvkGA;EACE,4BAAA;EAAA,uBAAA;AlB0kGF;AkBzkGE;EACE,gBAAA;AlB2kGJ;AkBzkGE;EACE,kBAAA;AlB2kGJ;AkBzkGI;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;AlB2kGN;AkB1kGM;EACE,eAAA;EACA,gBAAA;AlB4kGR;;AkBtkGA;EACE,kBAAA;EACA,gBAAA;AlBykGF;;AkBtkGA;EACE,aAAA;AlBykGF;;AkBtkGA;EACE,aAAA;EACA,YAAA;AlBykGF;AkBxkGE;EACE,kBAAA;AlB0kGJ;AkBzkGI;EACE,kBAAA;EACA,WAAA;AlB2kGN;AkB1kGM;EACE,WAAA;AlB4kGR;AkBzkGI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;AlB2kGN;AkBzkGI;EACE,YAAA;EACA,WAAA;AlB2kGN;AkBxkGI;EACE,uBAAA;EACA,kBAAA;AlB0kGN;AkBxkGI;EACE,uBAAA;AlB0kGN;AkBxkGI;EACE,gBAAA;AlB0kGN;AkBrkGQ;EACE,qBAAA;AlBukGV;AkBlkGI;EACE,uBAAA;AlBokGN;AkBnkGM;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AlBqkGR;AkBpkGQ;EACE,cAAA;AlBskGV;AkBpkGQ;EACE,qBAAA;EACA,4CAAA;AlBskGV;AkBnkGM;EACE,aAAA;AlBqkGR;AkBnkGM;EACE,iCAAA;AlBqkGR;;AkB9jGA;EACE,WAAA;AlBikGF;;AkB9jGA;EACE,aAAA;EACA,SAAA;AlBikGF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n@import \"../src/styles/variables.scss\";\n@import \"../src/Components/Navbar/navbar\";\n@import \"../src/styles/global\";\n@import \"../src/Build/build\";\n\n// Pages\n@import \"../src/Build/Auth/auth\";\n@import \"../src/Build/Pages/pages\";\n@import \"../src/Build/Pages/Projects/projects\";\n@import \"../src/Build/Pages/Projects/Single/single\";\n@import \"../src/Build/Pages/Log/log\";\n@import \"../src/Build/Pages/Employees/employees\";\n@import \"../src/Build/Pages/Employees/EmployeeModal/action\";\n@import \"../src/Build/Pages/Projects/Action/action\";\n@import \"../src//Build//Pages/Settings/Country/Action/action\";\n@import \"../src//Build/Pages/Settings/Job/job\";\n@import \"../src/Build/Pages/Sales/calculator/sales\";\n@import \"../src/Build/Pages/Finance/Dashboard/dashboard\";\n@import \"../src/Build/Pages/Finance/Expenses/expenses\";\n@import \"../src/Build/Pages/Sales/canban/canban\";\n@import \"../src/Build/Pages/Tasks/task\";\n","nav {\n  height: 80px;\n  position: relative;\n  z-index: 2;\n  .nav-wrapper {\n    box-shadow: 0px 4px 10px -8px rgba(0, 0, 0, 0.75);\n    width: 100%;\n    height: 100%;\n    padding-left: 20px;\n    padding-right: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .mobile_nav_wrapper {\n    display: none;\n  }\n  .left-menu {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .ant-avatar {\n    background-color: #f6f6f6;\n  }\n\n  .right-profile {\n    display: flex;\n    align-items: center;\n    .notifications {\n      margin-right: 40px;\n      cursor: pointer;\n    }\n    .profile {\n      display: flex;\n      gap: 7px;\n      align-items: center;\n      min-width: 150px;\n      .info {\n        h3 {\n          font-weight: 500;\n          font-size: 12px;\n        }\n        .pro_account {\n          font-family: cursive;\n        }\n        span {\n          font-size: 10px;\n          font-weight: 500;\n          padding: 2px 5px;\n          border-radius: 4px;\n          background-color: #edf8fe;\n          color: #517a9a;\n          text-transform: uppercase;\n          box-sizing: border-box;\n          border: 1px solid #32b4fd;\n        }\n      }\n      .avatar {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .my_image {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n      }\n    }\n    .drop-down {\n      margin-left: 20px;\n      cursor: pointer;\n    }\n  }\n}\n.my_image_big {\n  width: 200px;\n  height: 200px;\n  border-radius: 5px;\n}\n\n@media (max-width: 700px) {\n  nav {\n    box-shadow: 0px 2px 6px 0px #0d0a2c14;\n\n    .nav-wrapper {\n      display: none;\n    }\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    .mobile_nav_wrapper {\n      display: flex;\n      width: 100%;\n      .left-menu {\n        width: 100%;\n        justify-content: space-between;\n      }\n    }\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');\n\n*{\n    font-family: \"Inter\";\n}\n\n.ant-form-item-explain-error{\n    position: absolute;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    transition: background-color 5000s ease-in-out 0s; /* Smooth transition for background color */\n    -webkit-text-fill-color: #333 !important; /* Custom text color */\n    -webkit-box-shadow: 0 0 0px 1000px #fff inset; /* Change #fff to match your form's input background color */\n}\n\n/* For Firefox */\ninput:-moz-ui-autofill,\ninput:-moz-ui-autofill:hover,\ninput:-moz-ui-autofill:focus,\ninput:-moz-ui-autofill:active {\n    background-color: transparent !important;\n}",".ant-layout-sider-trigger {\n  position: absolute;\n  z-index: 5 !important;\n  top: 0;\n  background: transparent !important;\n  max-width: 30px;\n  height: 30px;\n  top: 20px;\n  left: 20px;\n  svg {\n    display: none;\n  }\n}\n\n.ant-layout-sider,\n.ant-layout-sider-dark,\n.ant-layout-sider-has-trigger {\n  background-color: transparent !important;\n}\n\n.ant-menu {\n  padding-bottom: 0;\n  background: #fff;\n  padding-top: 20px;\n  border: none !important;\n  padding-bottom: 20px;\n}\n.ant-layout-sider-children {\n  background-color: #fff !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between !important;\n  padding-right: 5px;\n  padding-left: 5px;\n  max-height: calc(100vh - 80px);\n  overflow: auto;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n.demo-logo-vertical {\n  display: none;\n}\n.secondary-menu {\n  border-top: 1px solid #e2e2e2 !important;\n  .ant-menu-item-selected {\n    background-color: transparent !important;\n  }\n  .ant-menu-item {\n    &:last-child {\n      color: $danger !important;\n    }\n  }\n}\n.ant-layout-sider,\n.ant-layout-sider-dark {\n  max-width: 240px !important;\n  width: 240px !important;\n  min-width: 240px !important;\n}\n.ant-layout-sider-has-trigger {\n  padding-bottom: 0 !important;\n}\n\n.ant-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  // padding-inline: calc(45% - 9px - 4px) ;\n}\n.ant-layout-sider-collapsed {\n  max-width: 64px !important;\n  width: 64px !important;\n  min-width: 64px !important;\n  .ant-menu-item,\n  .ant-menu-submenu-title {\n    padding-left: 11px !important;\n    padding-top: 5px;\n  }\n}\n.ant-menu-item-selected {\n  background-color: $primary !important;\n  color: #fff !important;\n}\n\n.ant-menu-sub {\n  background: #fff !important ;\n}\n\n.content {\n  padding: 20px;\n  position: relative;\n  height: calc(100vh - 80px);\n  overflow: auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.ant-drawer {\n  display: none;\n}\n\n@media (max-width: 1080px) {\n  .menu_desktop {\n    display: none;\n  }\n  .ant-drawer {\n    display: block;\n    .ant-drawer-header {\n      .ant-drawer-header-title {\n        display: flex;\n        justify-content: end;\n        button {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n",".login-page {\n  height: 100vh;\n  width: 100vw;\n  .login-page-wrapper {\n    display: flex;\n    height: 100%;\n    .leftside {\n      position: relative;\n      width: 50%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-image: url(../../Assets/images/login-back.png);\n      background-position: center;\n      background-size: cover;\n      background-repeat: no-repeat;\n      .header-logo {\n        width: 580px;\n        height: 100px;\n        transform: translateY(-100px);\n      }\n      .line {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n      }\n    }\n    .rightside {\n      width: 50%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .center {\n        max-width: 435px;\n        width: 100%;\n        display: flex;\n        transform: translateY(-50px);\n        flex-direction: column;\n        h1 {\n          font-size: 24px;\n          font-weight: 500;\n          color: #131111;\n        }\n\n        .ant-form-item-row {\n          display: flex;\n          flex-direction: column;\n          align-items: start;\n        }\n\n        .single-item {\n          margin-top: 40px;\n          height: 110px;\n          position: relative;\n          p {\n            font-size: 16px;\n            color: #131111;\n            margin-bottom: 10px;\n            span {\n              color: $danger;\n            }\n          }\n\n          input {\n            height: 64px;\n            width: 100%;\n            border-radius: 20px;\n            // border: 1px solid $secondary;\n            padding-left: 55px;\n            font-size: 18px;\n            background-color: #fff;\n          }\n\n          .ant-input-outlined:hover {\n            border-color: #37a141;\n          }\n\n          .ant-input-outlined {\n            border-color: $secondary;\n          }\n          .ant-input-outlined.ant-input-status-warning {\n            border-color: #faad14 !important;\n          }\n\n          .ant-input-outlined.ant-input-status-error {\n            border-color: $danger !important;\n          }\n\n          .ant-input-affix-wrapper {\n            height: 64px;\n            width: 100%;\n            border-radius: 20px;\n            padding-left: 55px;\n            font-size: 18px;\n            padding-right: 20px;\n            input {\n              height: 100%;\n              padding-left: 0;\n            }\n          }\n\n          .icon {\n            position: absolute;\n            z-index: 5;\n            left: 20px;\n            top: 55px;\n          }\n        }\n\n        .ant-form-item-explain-error {\n          margin-top: 10px;\n        }\n\n        .remember {\n          display: flex;\n          margin-top: 40px;\n          position: static;\n          height: 24px;\n          input {\n            width: 24px !important;\n            height: 24px !important;\n          }\n\n          .ant-checkbox-inner {\n            width: 24px !important;\n            height: 24px !important;\n            border-radius: 8px;\n            border: 1px solid #9c9c9c;\n            .ant-checkbox-checked {\n              border: 1px solid transparent !important;\n            }\n            &::after {\n              width: 8px;\n              height: 14px;\n            }\n          }\n        }\n\n        button {\n          margin-top: 75px;\n          width: 100%;\n          height: 57px;\n          font-size: 18px;\n          font-weight: 600;\n          background-color: $secondary;\n          border-radius: 20px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 700px) {\n  .login-page {\n    overflow: hidden;\n    margin-right: auto;\n    margin-left: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: 100dvw !important;\n    max-height: 100dvh !important;\n    display: flex;\n    justify-content: center;\n    .login-page-wrapper {\n      .leftside {\n        display: none;\n      }\n      .rightside {\n        width: 100%;\n        .center {\n          max-width: 100vw;\n        }\n      }\n    }\n  }\n}\n","// Colors\n$danger: #ED4C5C;\n$primary: #739BFF;\n$secondary: #1953E9;\n$gray: #686666;\n$secondary_gray: #7A7A7A;\n$third_gray:#828B96;\n$fourth_gray: #999999;\n$light_gray: #F1F2F4;\n$gray-blue: #A0AEC0;\n$fifth_gray:  #ACACAC;\n$light: #fff;\n$dark: #000;",".projects {\n  padding: 40px;\n  transition: opacity 0.3s ease;\n  position: relative;\n  .upper-section {\n    display: flex;\n    justify-content: space-between;\n    .download-btn {\n      display: flex;\n      gap: 30px;\n      button {\n        border-radius: 20px;\n      }\n      .ant-btn-primary {\n        background-color: $secondary;\n      }\n    }\n    .upper_filter {\n      display: flex;\n      gap: 20px;\n      .ant-select {\n        height: 40px;\n        width: 180px;\n        .ant-select-selector {\n          border-radius: 20px !important;\n          background-color: transparent;\n        }\n      }\n    }\n    .search-btn {\n      width: 330px;\n      .ant-btn-default {\n        border: none;\n        border-top-right-radius: 20px !important;\n        border-bottom-right-radius: 20px !important;\n        height: 38px;\n        width: 47px;\n        position: absolute;\n        top: 1px;\n        right: 1px;\n        z-index: 2;\n        background-color: transparent;\n      }\n      input {\n        border-radius: 20px !important;\n        width: 330px;\n        height: 40px;\n        padding-left: 20px;\n        padding-right: 50px;\n        background-color: transparent;\n      }\n    }\n\n    .add-project-btn {\n      border: 2px solid $secondary;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 9px 50px;\n      border-radius: 20px;\n      height: 44px;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      span {\n        font-size: 16px;\n        font-weight: 500;\n        transition: all 0.3s ease;\n        color: $secondary;\n      }\n      .icon {\n        transition: all 0.3s ease;\n        color: $secondary !important;\n      }\n\n      &:hover {\n        background-color: $secondary;\n        .icon {\n          color: $light !important;\n        }\n        span {\n          color: $light;\n        }\n      }\n    }\n  }\n\n  .projects-list {\n    margin-top: 30px;\n    ul {\n      list-style: none;\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n      gap: 40px;\n      li {\n        // max-width: 400px;\n        display: flex;\n        flex-direction: column;\n        border-top-right-radius: 12px;\n        border-top-left-radius: 12px;\n        background-color: $light;\n        .item {\n          .project-title {\n            padding: 20px;\n            margin-bottom: 20px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            h2 {\n              font-size: 28px;\n              font-weight: 600;\n              color: $secondary;\n              text-transform: uppercase;\n              max-width: 250px;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n            }\n            .icon {\n              color: $secondary !important;\n              width: 20px !important;\n              height: 20px !important;\n              cursor: pointer;\n            }\n          }\n          .project-info {\n            border-top-right-radius: 12px;\n            border-top-left-radius: 12px;\n            box-shadow: 0px -1px 30px 0px rgba(0, 0, 0, 10%);\n            .info {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              padding: 23px 12px;\n\n              .start-date,\n              .completion-date {\n                display: flex;\n                gap: 3px;\n                align-items: center;\n                .icon {\n                  width: 14px !important;\n                  height: 14px !important;\n                  color: $gray !important;\n                }\n                span {\n                  font-size: 12px;\n                  font-weight: 400;\n                  color: $gray;\n                }\n              }\n              .status {\n                font-size: 14px;\n                font-weight: 500;\n                color: $gray;\n              }\n            }\n\n            .proccess {\n              height: 22px;\n              display: flex;\n              position: relative;\n              justify-content: center;\n              align-items: center;\n              .proccess-line {\n                height: 100%;\n                position: absolute;\n                left: 0;\n                top: 0;\n                transition: all 0.3s ease;\n                width: 0%;\n              }\n              span {\n                font-size: 12px;\n                font-weight: 600;\n                position: relative;\n                z-index: 3;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.loader {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  // top: 0px;\n  transition: all 0.3s ease;\n  left: 0px;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgb(255, 255, 255, 0.5);\n  pointer-events: none;\n}\n\n@media (max-width: 1320px) {\n  .projects {\n    .projects-list {\n      ul {\n        grid-template-columns: 1fr 1fr;\n      }\n    }\n  }\n}\n",".single-project {\n  padding: 15px 80px;\n  .upper-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .back-home {\n    div {\n      display: flex;\n      align-items: center;\n      font-size: 16px;\n      font-weight: 500;\n      color: $fourth_gray;\n      .icon {\n        transform: rotate(90deg);\n        width: 20px !important;\n        height: 20px !important;\n        margin-right: 5px;\n        margin-left: -5px;\n      }\n    }\n  }\n  .save-btn {\n    button {\n      display: flex;\n      align-items: center;\n      flex-direction: row-reverse;\n      padding: 10px 30px !important;\n      border-radius: 12px;\n      background: $secondary;\n      gap: 5px;\n      &:disabled {\n        color: rgb(255, 255, 255, 0.7);\n        opacity: 0.7;\n      }\n      .ant-btn-icon {\n        margin-right: 0 !important;\n      }\n    }\n  }\n}\n\n.main {\n  padding-top: 35px;\n  display: flex;\n  justify-content: space-between;\n  gap: 100px;\n  .left {\n    max-width: 400px;\n    width: 100%;\n\n    h1 {\n      font-size: 36px;\n      font-weight: 600;\n      color: #131111;\n      margin-bottom: 5px;\n    }\n    p {\n      font-size: 16px;\n      font-weight: 400;\n      color: $fifth_gray;\n      margin-bottom: 10px;\n    }\n\n    .proccess {\n      height: 22px;\n      display: flex;\n      position: relative;\n      justify-content: center;\n      align-items: center;\n      border-radius: 10px;\n      overflow: hidden;\n      .proccess-line {\n        height: 100%;\n        position: absolute;\n        left: 0;\n        top: 0;\n        transition: all 1.2s ease;\n        width: 0%;\n        border-radius: 10px;\n      }\n      span {\n        font-size: 12px;\n        font-weight: 600;\n        position: relative;\n        z-index: 3;\n      }\n    }\n\n    .dates {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-top: 20px;\n      .start-date,\n      .completion-date {\n        display: flex;\n        align-items: center;\n        gap: 3px;\n        color: $gray !important;\n        font-size: 12px;\n        .icon {\n          width: 14px !important;\n          height: 14px !important;\n        }\n      }\n    }\n\n    .client-info {\n      margin-top: 20px;\n      label {\n        font-size: 20px;\n        font-weight: 500;\n        color: $dark;\n        input {\n          border-top: none;\n          border-left: none;\n          border-right: none;\n          padding-left: 0;\n          border-bottom: 1px solid #a09f9f;\n          border-radius: 0;\n          font-size: 16px;\n          font-weight: 400;\n          outline: none;\n          background-color: transparent;\n          padding-bottom: 10px;\n          margin-bottom: 20px;\n          margin-top: 15px;\n          width: 100%;\n          &:disabled {\n            color: #777777;\n          }\n          &:focus {\n            background: transparent;\n            outline: none;\n            box-shadow: none;\n          }\n        }\n\n        textarea {\n          margin-top: 15px;\n          height: auto !important;\n          border-top: none;\n          border-left: none;\n          border-right: none;\n          padding-left: 0;\n          border-bottom: 1px solid #a09f9f;\n\n          border-radius: 0;\n          font-size: 16px;\n          font-weight: 400;\n          outline: none;\n          background-color: transparent;\n          resize: none;\n          &:focus {\n            background: transparent;\n            outline: none;\n            box-shadow: none;\n          }\n        }\n        .ant-input {\n          height: auto !important;\n        }\n        .ant-input-outlined {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .right {\n    max-width: 533px;\n    width: 100%;\n\n    .todo {\n      border-radius: 10px;\n      overflow: hidden;\n      background-color: #fbfbfb;\n      .top {\n        height: 15px;\n        transition: all 1.2s ease;\n      }\n      h1 {\n        font-size: 24px;\n        font-weight: 500;\n        color: #131111;\n        padding-bottom: 32px;\n        border-bottom: 1px solid #dddddd;\n        margin-top: 33px;\n        padding-left: 20px;\n      }\n      .ant-list-empty-text {\n        height: 0px;\n        // display: none;\n        .ant-empty-normal {\n          padding: 0 !important;\n          display: flex;\n          justify-content: center;\n          &::after {\n            content: \"Any information left ?\";\n            position: absolute;\n            top: 10px;\n          }\n        }\n        &::after {\n          display: none;\n        }\n        .ant-empty-image {\n          display: none;\n        }\n        .ant-empty-description {\n          display: none;\n        }\n      }\n      .ant-list {\n        border: none;\n      }\n      .ant-list-item {\n        padding: 0;\n        padding-left: 20px;\n        padding-right: 12px;\n        display: flex;\n        align-items: center;\n        margin-top: 25px;\n        border-bottom: none;\n        label {\n          max-width: 80%;\n          p {\n            width: 100%;\n            font-size: 16px;\n            font-weight: 400;\n            color: #3b3b3b;\n            word-wrap: break-word;\n          \n          }\n        }\n\n        .custom-checkbox {\n          display: flex !important;\n          flex-direction: row;\n          align-items: center;\n          width: 100%;\n          position: relative;\n          input {\n            opacity: 0;\n            position: absolute;\n            width: 100%;\n          }\n\n          .checkmark {\n            position: relative;\n\n            top: 0;\n            left: 0;\n            height: 24px;\n            min-width: 24px;\n            display: inline-block;\n            margin-right: 10px;\n            border: 1px solid #777777;\n            border-radius: 5px;\n            transition: all 0.3s ease;\n            background-position: center;\n            cursor: pointer;\n            &:hover {\n              background-color: #fbfafa;\n            }\n            &:after {\n              content: \"\";\n              position: absolute;\n              display: none;\n            }\n          }\n\n          input:checked + .checkmark {\n            background-color: #d0f9d4;\n            border: 1px solid #36b151;\n            background-image: url(../../../../Assets/icons/checked.svg);\n            background-repeat: no-repeat;\n            background-position: center;\n            background-size: 16px;\n          }\n        }\n\n        .icon {\n          cursor: pointer;\n        }\n\n        li {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n      .field {\n        display: flex;\n        margin-top: 25px;\n        padding-top: 12px;\n        padding-bottom: 12px;\n        border-top: 1px solid #dddddd;\n        padding-left: 10px;\n        padding-right: 10px;\n        gap: 10px;\n        textarea {\n          border: none;\n          background-color: transparent;\n          outline: none;\n          box-shadow: none;\n          resize: none;\n          height: fit-content;\n          border: 1px solid #d6d6d6;\n        }\n\n        button {\n          display: flex;\n          align-items: center;\n          flex-direction: row-reverse;\n          color: #131111;\n          font-size: 16px;\n          border: 1px solid #d6d6d6;\n          .ant-btn-icon {\n            margin-right: 0;\n            margin-left: 5px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.delete-pop-up {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .ant-modal-content {\n    width: 400px !important;\n    top: 0 !important;\n    padding: 20px !important;\n    border-radius: 20px !important;\n  }\n\n  .ant-modal {\n    width: 500px !important;\n    top: 0px !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  .ant-modal-root {\n    width: 500px !important;\n  }\n  .ant-modal-wrap {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n}\n",".projects_log{\n    border-radius: 16px;\n    padding: 30px 20px;\n    background-color: $light;\n    .page-title{\n        margin-bottom: 22px;\n        h1{\n            font-size: 32px;\n            font-weight: 600;\n            margin-bottom: 12px;\n        }\n        p{\n            font-weight: 400;\n            font-size: 20px;\n            color: $secondary_gray;\n        }\n    }\n\n    .upper-section{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        .left{\n            display: flex;\n            gap: 20px;\n            .search-btn{\n                width: 330px;\n                .ant-btn-default{\n                    border: none;\n                    border-top-right-radius: 20px !important;\n                    border-bottom-right-radius: 20px !important;\n                    height: 38px;\n                    width: 47px;\n                    position: absolute;\n                    top: 1px;\n                    right: 1px;\n                    z-index: 2;\n                    background-color: transparent;\n                }\n                input{\n                    border-radius: 20px !important;\n                    width: 330px;\n                    height: 40px;\n                    padding-left: 20px;\n                    padding-right: 50px;\n                    background-color: transparent;\n                    \n                }\n            }\n            .select{\n                position: relative;\n                cursor: pointer;\n                .icon{\n                    width: 16px !important;\n                    height: 16px !important;\n                    position: absolute;\n                    right: 12px;\n                    top: 12px;\n                    pointer-events: none;\n                    \n                }\n                .ant-select-selector{\n                    height: 40px;\n                    width: 170px;\n                    border-radius: 20px;\n                    .ant-select-selection-item{\n                        padding-left: 12px;\n\n                        \n                    }\n                    \n                    \n                }\n\n                .ant-select-arrow{\n                    display: none !important;\n                    opacity: 0 !important;\n                }\n                \n            }\n        }\n        .download-btn{\n            button{\n                border: 1px solid $secondary;\n            }\n        }\n    }\n\n    .table{\n        padding-top: 40px;\n        position: relative;\n        .ant-table{\n            border-radius: 0px !important;\n        }\n        .ant-table-header{\n            border-radius: 0px;\n        }\n        .ant-table-thead{\n            border-radius: 0px !important;\n            tr{\n                th{\n                    border-radius: 0px !important;\n                    font-size: 12px;\n                    color: $third_gray;\n                    font-weight: 500;\n                    border-left: 0.5px solid #E8E8E8;\n                    border-right: 0.5px solid #E8E8E8;\n                    &:first-child{\n                        border-left: none !important;\n\n                    }\n                    &:last-child{\n                        border-right: none !important;\n                    }\n                    &::before{\n                        background: none !important;\n                    }\n                }\n                \n            }\n        }\n\n        .ant-table-row{\n            td{\n                border: 0.5px solid #E8E8E8 !important;\n                font-size: 14px;\n                font-weight: 500;\n                &:first-child{\n                    border-left: none !important;\n                }\n                &:last-child{\n                    border-right: none !important;\n                    padding: 0 !important;\n                    padding-right: 5px !important;\n                    padding-left: 5px !important;\n                    \n                }\n                &:nth-child(6){\n                    padding-left: 0;\n                    padding-bottom: 0;\n                    padding: 0;\n\n                }\n                .status{\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    border-radius: 30px;\n                    font-weight: 400;\n                    font-size: 10px;\n                    width: 100px;\n                    height: 24px;\n                    margin-right: auto;\n                    margin-left: auto;\n                }\n                .date{\n                    display: flex;\n                    align-items: center;\n                    gap: 5px;\n                    font-size: 13px;\n                    font-weight: 400;\n\n                    margin-right: auto;\n                    margin-left: auto;\n                    max-width: 100%;\n                    .icon{\n                        width: 16px !important;\n                        height: 16px !important;\n                    }\n                }\n                .updated-by{\n                    font-size: 13px;\n                }\n                \n                .comment{\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n                    padding-right: 10px;\n                    padding-left: 10px;\n                    position: relative;\n                    span{\n                        display: flex;\n                        align-items: center;\n                        cursor: pointer;\n                        padding: 0 !important; \n                        justify-content: space-between;\n                        gap: 2px;\n                        width: 100%;\n                        padding-bottom: 16px !important;\n                        padding-top: 16px !important;\n                        p{\n                            white-space: nowrap;\n                            max-width: 110px;\n                            overflow: hidden;\n                            text-overflow: ellipsis;\n                        }\n                        \n                    }\n                    \n                    \n                    .icon{\n                        min-width: 14px !important;\n                        min-height: 14px !important;\n                        max-width: 14px !important;\n                        max-height: 14px !important;\n                        color: rgba(203, 213, 224, 1) !important;\n                        position: relative;\n                    }\n                    button{\n                        background: none !important;\n                        color: $dark;\n                        border: none !important;\n                        box-shadow: none !important;\n                        outline: none !important;\n                        padding: 0;\n                        div{\n                            display: none;\n                        }\n                    }\n                    \n                }\n            }\n        }\n\n        .ant-pagination{\n            justify-content: start;\n            position: relative;\n            li{\n                &:last-child{\n                    position: absolute;\n                    right: 0;\n                }\n                \n            }\n            .ant-pagination-next, .ant-pagination-prev{\n                border: 1px solid $light_gray !important;\n            }\n        }\n\n        .item-amout{\n            position: absolute;\n            right: 120px;\n            bottom: 25px;\n            font-size: 12px;\n            font-weight: 500;\n            color: #687588;\n        }\n    }\n}\n.ant-popover{\n    max-width: 300px !important;\n}\n\n@media(max-width:1400px){\n    .projects_log{\n        .table{\n            th{\n                padding: 12px !important;\n            }\n            td{\n                padding: 8px !important;\n                &:nth-child(6){\n                    padding-left: 0;\n                    padding-bottom: 0;\n                    padding: 0;\n                }\n                .comment{\n                    padding-left: 8px !important;\n                    padding-right: 8px !important;\n                    p{\n                        width: 70px;\n                    }\n                }\n            }\n\n        }\n    }\n}",".employees {\n  .upper-section {\n    .download-btn {\n      display: flex;\n      gap: 30px;\n      button {\n        border-radius: 20px;\n      }\n      .ant-btn-primary {\n        background-color: $secondary;\n      }\n    }\n  }\n\n  .uppercase {\n    text-transform: uppercase;\n  }\n\n  .table {\n    .ant-table-thead {\n      tr {\n        th {\n          border-left: none !important;\n          border-right: none !important;\n\n          font-size: 14px;\n          color: #434343;\n\n          .salary-column-header {\n            display: flex;\n            justify-content: space-between;\n            .icon {\n              cursor: pointer;\n              transition: all 0.3s ease;\n            }\n          }\n        }\n      }\n    }\n    .ant-table-row {\n      &:hover {\n        .hide-salary {\n          &::after {\n            background-color: #fafafa !important;\n          }\n        }\n      }\n      td {\n        border-left: none !important;\n        border-right: none !important;\n\n        &:nth-child(2) {\n          font-size: 12px;\n          font-weight: 400;\n        }\n\n        &:nth-child(7) {\n          font-size: 12px;\n          font-weight: 400;\n        }\n        &:nth-child(8) {\n          font-size: 12px;\n          font-weight: 400;\n        }\n        &:nth-child(6) {\n          padding-left: 14px !important;\n        }\n        .employee-info {\n          display: flex;\n          background: none !important;\n          position: relative;\n          span {\n            display: flex;\n            align-items: center;\n            cursor: pointer;\n            padding: 0 !important;\n            width: 100%;\n          }\n          .employee {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            top: 0;\n            width: 100%;\n            .avatar {\n              display: flex;\n              img {\n                width: 24px;\n                height: 24px;\n                object-fit: cover;\n                border-radius: 50%;\n              }\n            }\n            .personal-info {\n              p {\n                color: #a0aec0;\n                font-size: 10px;\n                font-weight: 400;\n              }\n              h4 {\n                font-size: 12px;\n                font-weight: 400;\n              }\n            }\n          }\n\n          .icon {\n            color: #a0aec0 !important;\n          }\n        }\n\n        .job {\n          span {\n            font-size: 12px;\n            font-weight: 400;\n          }\n          p {\n            font-size: 10px;\n            font-weight: 400;\n            color: $gray-blue;\n          }\n        }\n\n        .file {\n          .icon {\n            color: $danger !important;\n            cursor: pointer;\n          }\n        }\n\n        .salary {\n          font-size: 12px;\n          font-weight: 400;\n          padding: 5px;\n          display: flex;\n          justify-content: center;\n          text-align: center;\n          position: relative;\n          transition: all 0.3s ease;\n        }\n\n        .hide-salary {\n          transition: all 0.3s ease;\n\n          &::after {\n            content: \"*********\";\n            position: absolute;\n            background-color: #fff;\n            width: 100%;\n            height: 100%;\n            top: 0;\n            left: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: all 0.3s ease;\n          }\n          &:hover {\n            &::after {\n              opacity: 0;\n            }\n          }\n        }\n\n        .edit {\n          display: flex;\n          align-items: center;\n          gap: 14px;\n          .icon {\n            width: 18px !important;\n            cursor: pointer;\n            &:first-child {\n              color: #624de3 !important;\n            }\n            &:last-child {\n              color: #a30d11 !important;\n            }\n          }\n        }\n      }\n    }\n\n    .total-salary {\n      font-weight: bold;\n      justify-content: end;\n      display: flex;\n      gap: 10px;\n      .amount-wrapper {\n        display: flex;\n        width: fit-content;\n        position: relative;\n        .total-salary-amount {\n          opacity: 0;\n          transition: all 0.3s ease;\n          font-weight: normal;\n          cursor: pointer;\n        }\n        .hide-total-salary {\n          position: absolute;\n          padding-top: 3px;\n          font-weight: normal;\n          transition: all 0.3s ease;\n          width: 100%;\n          cursor: pointer;\n          height: 100%;\n          background-color: #fafafa;\n          display: flex;\n          //   align-items: center;\n          justify-content: center;\n          left: 0;\n          top: 0;\n        }\n        &:hover {\n          opacity: 1;\n          .hide-total-salary {\n            opacity: 0;\n            pointer-events: none;\n          }\n          .total-salary-amount {\n            opacity: 1;\n          }\n        }\n      }\n    }\n  }\n}\n\n.pop-over {\n  display: flex;\n  flex-direction: column;\n  font-size: 10px;\n  font-weight: 400;\n  gap: 5px;\n  .email {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 4px;\n    color: $gray-blue;\n  }\n  .icon {\n    width: 12px !important;\n    height: 12px !important;\n    cursor: pointer;\n  }\n}\n\n.modal-backdrop2 {\n  width: 100%;\n  position: fixed;\n  height: 100%;\n  z-index: 10000;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #00000050;\n  .prewiev-modal2 {\n    width: 85%;\n\n    height: 85%;\n    overflow: hidden;\n    border-radius: 10px;\n    background: #fff;\n    .modal-header {\n      padding: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      .modal-title {\n        width: 80%;\n      }\n      button {\n        width: 30px;\n        height: 30px;\n        background: transparent;\n        border: none;\n      }\n    }\n    .file-box {\n      width: 100%;\n      height: 100%;\n\n      .content-image {\n        background: #ccc;\n\n        width: 100%;\n        height: 100%;\n        object-fit: fill;\n      }\n    }\n  }\n}\n",".ant-modal-content {\n  //   width: 1287px !important;\n  // top: 0 !important;/\n  padding: 30px 50px 60px 50px !important;\n}\n\n.ant-modal {\n  //   width: 1287px !important;\n  height: 600px !important;\n  top: 0px !important;\n  // padding-bottom: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n// .expenses-modal {\n//   border: 1px solid red;\n//   .ant-modal {\n//     border: 1px solid blue !important;\n//   }\n// }\n\n.ant-modal-root {\n  //   width: 1287px !important;\n  // margin-top: 0 !important;\n}\n.ant-modal-wrap {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  // margin-top: 0 !important;/\n}\n\n.download-selected_file {\n  font-size: 20px;\n  transform: translateX(50px);\n  color: #222;\n}\n\n.cencel-file-popup {\n  cursor: pointer;\n}\n\n.form-wrapper {\n  .title {\n    h1 {\n      font-size: 24px;\n      font-weight: 500;\n      margin-bottom: 5px;\n      color: #131111;\n    }\n    p {\n      font-weight: 400;\n      font-size: 14px;\n      color: #848282;\n    }\n  }\n\n  .avatar {\n    height: 120px;\n    width: 120px;\n    position: relative;\n    margin-top: 25px;\n    .icon-wrapper {\n      position: absolute;\n      cursor: pointer;\n      height: 30px;\n      width: 30px;\n      top: 3px;\n      right: 3px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      background-color: $secondary;\n      .icon {\n        width: 14px !important;\n        height: 14px !important;\n        color: $light !important;\n      }\n    }\n    .avatar-photo {\n      border-radius: 50%;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #f2f2f2;\n      .icon {\n        width: 57px !important;\n        height: 57pc !important;\n      }\n    }\n  }\n  .ant-select {\n    // border-color: #d9d9d9 !important;\n  }\n\n  .input-wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    column-gap: 40px;\n    row-gap: 33px;\n    padding-top: 27px;\n    padding-bottom: 30px;\n    .ant-input-status-error {\n      // border-color: #d9d9d9 !important;\n    }\n\n    .single-input-item {\n      position: relative;\n      label {\n        font-size: 16px;\n        font-weight: 500;\n        color: #131111;\n      }\n      input {\n        height: 44px;\n      }\n\n      .ant-select {\n        height: 44px !important;\n        position: relative;\n        span {\n        }\n      }\n      .ant-picker {\n        height: 44px !important;\n      }\n      .ant-form-item {\n        margin-bottom: 0;\n      }\n\n      .ant-form-item-has-error {\n        .PhoneInput {\n          input {\n            border-color: #ff4d4f;\n          }\n        }\n      }\n\n      .PhoneInput {\n        // border: 1px solid red;\n        border: none !important;\n        input {\n          border-radius: 6px;\n          outline: none;\n          border: 1px solid #d9d9d9;\n          padding: 4px 11px;\n          font-size: 14px;\n          transition: all 0.3s ease;\n          &::placeholder {\n            color: #bfbfbf;\n          }\n          &:focus {\n            border-color: #1677ff;\n            box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);\n          }\n        }\n        .PhoneInputCountry {\n          display: none;\n        }\n        .PhoneInput--focus {\n          border: 1px solid none !important;\n        }\n      }\n    }\n\n    .salary {\n      gap: 10px;\n      display: flex;\n      justify-content: center;\n      align-items: end;\n\n      .ant-form-item-control-input-content {\n        display: flex !important;\n        gap: 10px;\n        align-items: center;\n      }\n      .ant-form-item-control-input-content {\n      }\n    }\n\n    .calendar {\n      position: relative;\n      .ant-picker {\n        display: flex;\n        padding-right: 40px;\n        span {\n          display: none;\n        }\n        input {\n          border: none;\n        }\n      }\n\n      .icon {\n        position: absolute;\n        top: 40px !important;\n        z-index: 10;\n        right: 10px;\n        top: 10px !important;\n        pointer-events: none;\n      }\n    }\n  }\n\n  .expenses-input-wrapper {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  .salary {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.small-modal {\n  .min-title {\n    padding: 20px;\n    h1 {\n      font-size: 24px;\n      font-weight: 600;\n      color: #131111;\n    }\n  }\n\n  ul {\n    padding-left: 20px;\n    padding-right: 20px;\n    list-style: none;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 20px;\n    li {\n      border-radius: 5px;\n      height: 170px;\n      background-color: #fdfdfd;\n      border: 1px solid #f7f7f7;\n      .item-wrapper {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        .file-img {\n          margin-top: 20px;\n          .icon {\n            max-width: 85px !important;\n            max-height: 113px !important;\n            width: 85px !important;\n            height: 113px !important;\n            color: #eb1f1f !important;\n          }\n        }\n        .file-name {\n          display: flex;\n          height: 30px;\n          align-items: center;\n          padding-bottom: 5px;\n          padding-right: 7px;\n          padding-left: 7px;\n          input {\n            height: 20px;\n            border: none !important;\n            outline: none;\n            padding-right: 0;\n            font-size: 12px;\n          }\n\n          span {\n            font-size: 12px;\n            text-align: center;\n            max-width: 120px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n          .ant-input-outlined {\n            border: none;\n            box-shadow: none;\n            border-radius: 0px;\n            padding-right: 2px;\n          }\n\n          .icon {\n            color: #36b151 !important;\n            cursor: pointer;\n          }\n        }\n        .delete {\n          position: absolute;\n          top: 10px;\n          right: 10px;\n          cursor: pointer;\n          .icon {\n            width: 14px !important;\n            height: 14px !important;\n          }\n        }\n      }\n    }\n    .upload {\n      max-width: 143px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      label {\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        align-items: center;\n        input {\n          display: none;\n        }\n        .plus {\n          border: 3px solid #eb1f1f;\n          cursor: pointer;\n          width: 60px;\n          height: 60px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 10px;\n          span {\n            font-size: 10px;\n            font-weight: 500;\n            color: #131111;\n          }\n          .icon {\n            transform: rotateZ(45deg);\n            width: 30px !important;\n            height: 30px !important;\n            color: #eb1f1f !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.password {\n  height: 44px !important;\n  .ant-input-affix-wrapper {\n    height: 44px !important;\n    width: 100%;\n    // border: 1px solid $secondary;\n    font-size: 18px;\n    display: flex;\n    .ant-input {\n      max-height: 34px !important;\n      display: flex;\n    }\n    input {\n      height: 44px !important;\n      padding-top: 0 !important;\n      padding-left: 0;\n      font-size: 14px;\n      &::placeholder {\n        font-size: 14px;\n      }\n    }\n  }\n}\n",".min-modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .ant-modal-content {\n    width: 773px !important;\n    top: 0 !important;\n    padding: 0px !important;\n    border-radius: 20px !important;\n  }\n\n  .ant-modal {\n    width: 773px !important;\n    top: 0px !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  .ant-modal-root {\n    width: 773px !important;\n    // margin-top: 0 !important;\n  }\n  .ant-modal-wrap {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    // margin-top: 0 !important;/\n  }\n\n  .ant-modal-footer {\n    padding-bottom: 30px !important;\n    padding-right: 30px !important;\n\n    button {\n      border-radius: 12px;\n      &:last-child {\n        background-color: $secondary;\n        color: $light;\n      }\n    }\n  }\n\n  .form-wrapper {\n    .title {\n      padding: 30px 30px 20px 30px;\n      border-bottom: 1px solid #c2c0c0;\n      justify-content: space-between;\n      h1 {\n        font-size: 24px;\n        font-weight: 500;\n        color: #131111;\n        margin-bottom: 5px;\n      }\n      p {\n        font-size: 14px;\n        font-weight: 400;\n        color: #848282;\n      }\n    }\n\n    .upper {\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n      gap: 20px;\n      padding: 30px;\n      .single-item {\n        input {\n          width: 100%;\n          height: 46px !important;\n          border-radius: 10px;\n          font-size: 16px;\n          &::placeholder {\n            font-size: 16px;\n          }\n        }\n        .ant-select {\n          width: 100% !important;\n          height: 46px !important;\n          border-radius: 10px !important;\n\n          .ant-select-selection-item {\n            margin-bottom: 0 !important;\n          }\n          .ant-select-selector {\n            border-radius: 10px !important;\n            display: flex;\n            align-items: center;\n          }\n          .ant-select-selection-placeholder {\n            margin-bottom: 0 !important;\n            padding-bottom: 0 !important;\n            color: #c2c0c0;\n          }\n          .ant-select-suffix {\n            margin-bottom: 0 !important;\n          }\n        }\n\n        .ant-picker {\n          height: 46px !important;\n          border-radius: 10px;\n          display: flex;\n          padding-left: 40px;\n\n          span {\n            display: none;\n          }\n          input {\n            border: none;\n          }\n        }\n      }\n      .calendar {\n        position: relative;\n        .icon {\n          position: absolute;\n          top: 40px !important;\n          z-index: 100;\n          left: 10px;\n        }\n      }\n    }\n\n    .full-width {\n      grid-template-columns: 1fr;\n      .upper {\n        .single-item {\n          .ant-select {\n            width: 100% !important;\n            height: 30px !important;\n            border-radius: 10px !important;\n            border: 1px solid red;\n            .ant-select-selection-item {\n              margin-bottom: 0 !important;\n            }\n            .ant-select-selector {\n              border-radius: 10px !important;\n              display: flex;\n              align-items: center;\n            }\n            .ant-select-selection-placeholder {\n              margin-bottom: 0 !important;\n              padding-bottom: 0 !important;\n              color: #c2c0c0;\n            }\n            .ant-select-suffix {\n              margin-bottom: 0 !important;\n            }\n          }\n\n          .ant-select-selector {\n            border: 1px solid red;\n          }\n        }\n      }\n    }\n\n    .ant-select-selection-item {\n    }\n\n    .ant-select-selection-overflow {\n      height: 40px;\n      padding-left: 5px;\n    }\n\n    .columns-2 {\n      grid-template-columns: 1fr 1fr 1fr;\n    }\n    .textarea {\n      padding-left: 30px;\n      padding-right: 30px;\n      textarea {\n        border-radius: 10px;\n        max-height: 223px;\n        height: 300px;\n        padding: 10px;\n        padding-left: 15px;\n        min-height: 100px;\n        &::placeholder {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n}\n",".small-modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .ant-modal-content {\n    width: 500px !important;\n    top: 0 !important;\n    padding: 0px !important;\n    border-radius: 20px !important;\n  }\n\n  .ant-modal {\n    width: 500px !important;\n    top: 0px !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  .ant-modal-root {\n    width: 500px !important;\n    // margin-top: 0 !important;\n  }\n  .ant-modal-wrap {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    // margin-top: 0 !important;/\n  }\n\n  .ant-modal-footer {\n    padding-bottom: 30px !important;\n    padding-right: 30px !important;\n\n    button {\n      border-radius: 12px;\n      &:last-child {\n        background-color: $secondary;\n        color: $light;\n      }\n    }\n  }\n\n  .form-wrapper {\n    .title {\n      padding: 30px 30px 20px 30px;\n      border-bottom: 1px solid #c2c0c0;\n      justify-content: space-between;\n      h1 {\n        font-size: 24px;\n        font-weight: 500;\n        color: #131111;\n        margin-bottom: 5px;\n      }\n    }\n\n    .single-item {\n      padding-left: 30px;\n      margin-top: 30px;\n      max-width: 240px;\n      p {\n        margin-bottom: 10px;\n        font-size: 16px;\n        font-weight: 400;\n        color: #131111;\n      }\n      input {\n        width: 100%;\n        height: 46px !important;\n        border-radius: 10px;\n        font-size: 16px;\n        &::placeholder {\n          font-size: 16px;\n        }\n      }\n\n      .ant-switch-checked {\n        background: #34c759;\n      }\n      .ant-switch-checked:hover {\n        background: #34c759 !important;\n      }\n    }\n    .integration {\n      display: flex !important;\n      max-width: 100%;\n      padding-right: 30px;\n      align-items: center;\n      gap: 10px;\n      .percentage-icon {\n        border: 1px solid #d9d9d9;\n        height: 46px;\n        width: 46px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 10px;\n        font-size: 20px;\n        transform: translateY(3px);\n      }\n    }\n  }\n}\n\n.company-wage {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  .percentage-icon {\n    border: 1px solid #d9d9d9;\n    height: 46px;\n    min-width: 46px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    font-size: 20px;\n    transform: translateY(3px);\n  }\n}\n",".settings-table {\n  background-color: $light;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid transparent;\n  .ant-table-thead {\n    border-radius: 0px !important;\n    tr {\n      th {\n        &:last-child {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        .percentage {\n          width: 100%;\n          display: flex;\n          justify-content: center;\n        }\n        // &:nth-child(2) {\n        //   display: flex;\n        //   align-items: center;\n        //   justify-content: center;\n        // }\n        &:first-child {\n          padding-left: 20px !important;\n        }\n      }\n    }\n  }\n\n  .status {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    span {\n      display: flex;\n      align-items: center;\n      gap: 30px;\n    }\n  }\n\n  .switch {\n    display: flex;\n    justify-content: center;\n  }\n  .ant-switch-checked {\n    background: #34c759;\n  }\n  .ant-switch-checked:hover {\n    background: #34c759 !important;\n  }\n  .ant-table-row {\n    td {\n      &:last-child {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .percentage {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n      }\n      //   &:nth-child(2) {\n      //     display: flex;\n      //     align-items: center;\n      //     justify-content: center;\n      //   }\n      &:first-child {\n        padding-left: 20px !important;\n      }\n    }\n  }\n\n  .edit {\n    .icon {\n      color: #624de3 !important;\n      cursor: pointer;\n    }\n  }\n\n  .wage-edit {\n  }\n\n  .bottom-side {\n    display: flex;\n    justify-content: end;\n    margin-top: 22px;\n    margin-bottom: 23px;\n    padding-right: 22px;\n    button {\n      border-radius: 20px;\n      display: flex;\n      flex-direction: row-reverse;\n      align-items: center;\n      background-color: $secondary;\n      span {\n        margin-right: 0 !important;\n        margin-left: 5px;\n      }\n    }\n  }\n}\n\n.filter-checkbox {\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  margin: 5px;\n  input {\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n  }\n\n  .checkmark {\n    position: relative;\n\n    top: 0;\n    left: 0;\n    height: 24px;\n    min-width: 24px;\n    display: inline-block;\n    margin-right: 10px;\n    border: 1px solid #777777;\n    border-radius: 5px;\n    transition: all 0.3s ease;\n    background-position: center;\n    cursor: pointer;\n    &:hover {\n      background-color: #fbfafa;\n    }\n    &:after {\n      content: \"\";\n      position: absolute;\n      display: none;\n    }\n  }\n\n  input:checked + .checkmark {\n    background-color: #d0f9d4;\n    border: 1px solid #36b151;\n    background-image: url(../../../../Assets/icons/checked.svg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 16px;\n  }\n}\n",".sales {\n  border-radius: 16px;\n  background-color: $light;\n  min-height: 100%;\n\n  .page-title {\n    display: flex;\n    padding: 30px;\n    align-items: center;\n    justify-content: space-between;\n    .title-wrapper {\n      h1 {\n        font-size: 32px;\n        font-weight: 500;\n        margin-bottom: 11px;\n      }\n      p {\n        font-size: 20px;\n        font-weight: 400;\n        color: #7a7a7a;\n      }\n    }\n    .calculation-btns {\n      display: flex;\n      gap: 40px;\n      align-items: center;\n    }\n    .calculate-btn {\n      display: flex;\n      height: 40px;\n      align-items: center;\n      padding-right: 30px;\n      padding-left: 33px;\n      border-radius: 20px;\n      flex-direction: row-reverse;\n      gap: 10px;\n      background-color: $secondary;\n      .ant-btn-icon {\n        margin-right: 0;\n      }\n    }\n\n    .clear-btn {\n      background-color: transparent;\n      border: 1px solid $secondary;\n      color: $secondary;\n      &:hover {\n        background-color: transparent;\n        color: $secondary;\n      }\n    }\n  }\n\n  .form-wrapper {\n    .client-info {\n      display: flex;\n      border-bottom: 1px solid #e8e8e8;\n      gap: 60px;\n      padding: 0 30px 20px 30px;\n      .single-input-item {\n        max-width: 282px;\n        width: 100%;\n        label {\n          font-size: 16px;\n          font-weight: 500;\n          color: #131111;\n        }\n        input {\n          height: 44px;\n        }\n\n        .ant-select {\n          height: 44px !important;\n          position: relative;\n        }\n      }\n    }\n    .project-info {\n      display: flex;\n      gap: 60px;\n      padding: 30px 30px 30px 30px;\n      .single-input-item {\n        max-width: 282px;\n        width: 100%;\n        label {\n          font-size: 16px;\n          font-weight: 500;\n          color: #131111;\n        }\n        input {\n          height: 44px;\n        }\n      }\n      .multiple {\n        .ant-select {\n          min-height: 44px;\n          position: relative;\n          .ant-select-selection-overflow-item {\n            width: 100%;\n          }\n          .ant-select-selection-item {\n            min-height: 40px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            background-color: #e3e9f9;\n            width: 100%;\n            .ant-select-selection-item-content {\n              font-size: 14px;\n              font-weight: 400;\n            }\n          }\n        }\n      }\n      .ant-space-compact {\n        height: 48px;\n      }\n      .twin-input {\n        // width: 100% !important;\n        max-width: 408px !important;\n        width: 100% !important;\n        .ant-select {\n          width: 100%;\n          height: 48px;\n          width: 270px;\n        }\n        input {\n          height: 48px;\n          width: 80px !important;\n        }\n        button {\n          height: 48px;\n          background-color: $secondary;\n          &:disabled {\n            color: rgba(255, 255, 255, 0.5);\n            background-color: $primary;\n          }\n        }\n      }\n      .team-list {\n        padding-top: 10px;\n        // max-width: 300px;\n        width: 100%;\n        padding-top: 20px;\n        ul {\n          list-style: none;\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          li {\n            border: 1px solid #dcdce4;\n            border-radius: 10px;\n            .item {\n              display: flex;\n              padding: 4px;\n              gap: 8px;\n              padding-right: 14px;\n              .fullname {\n                padding: 4px 16px;\n                background-color: #e3e9f9;\n                width: 100%;\n                border-radius: 6px;\n                h4 {\n                  font-size: 12px;\n                  font-weight: 400;\n                }\n                span {\n                  font-size: 10px;\n                  font-weight: 400;\n                  color: #8e8ea9;\n                }\n              }\n              .duration {\n                display: flex;\n                align-items: center;\n                padding-right: 12px;\n                background-color: #e3e9f9;\n                border-radius: 6px;\n                margin-right: 4px;\n                font-size: 12px;\n                input {\n                  border: none;\n                  font-size: 12px;\n                  width: 45px !important;\n                  background-color: transparent;\n                  &:focus {\n                    box-shadow: none;\n                  }\n                }\n              }\n              .anticon {\n                cursor: pointer;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.small-modal {\n  .ant-modal-content {\n    position: relative;\n    overflow: hidden;\n    .min-title {\n      padding-top: 15px;\n      padding-bottom: 8px;\n      display: flex;\n      align-items: center;\n    }\n    .confirm-content {\n      padding: 20px 30px 0 30px;\n    }\n    .modal-loader {\n      width: 100%;\n      background-color: rgba(255, 255, 255, 1);\n      height: 100%;\n      position: absolute;\n      opacity: 1;\n      z-index: 9999;\n      top: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transform: all 0.3s ease;\n\n      .loader-wrapper {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 60px;\n        span {\n          font-size: 32px;\n          font-weight: 400;\n          color: rgba(122, 122, 122, 1);\n        }\n      }\n\n      .lds-roller,\n      .lds-roller div,\n      .lds-roller div:after {\n        box-sizing: border-box;\n      }\n      .lds-roller {\n        display: inline-block;\n        position: relative;\n        transform: scale(1.5);\n        width: 80px;\n        height: 80px;\n      }\n      .lds-roller div {\n        animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n        transform-origin: 40px 40px;\n      }\n      .lds-roller div:after {\n        content: \" \";\n        display: block;\n        position: absolute;\n        width: 7.2px;\n        height: 7.2px;\n        border-radius: 50%;\n        background: $secondary;\n        margin: -3.6px 0 0 -3.6px;\n      }\n      .lds-roller div:nth-child(1) {\n        animation-delay: -0.036s;\n      }\n      .lds-roller div:nth-child(1):after {\n        top: 62.62742px;\n        left: 62.62742px;\n      }\n      .lds-roller div:nth-child(2) {\n        animation-delay: -0.072s;\n      }\n      .lds-roller div:nth-child(2):after {\n        top: 67.71281px;\n        left: 56px;\n      }\n      .lds-roller div:nth-child(3) {\n        animation-delay: -0.108s;\n      }\n      .lds-roller div:nth-child(3):after {\n        top: 70.90963px;\n        left: 48.28221px;\n      }\n      .lds-roller div:nth-child(4) {\n        animation-delay: -0.144s;\n      }\n      .lds-roller div:nth-child(4):after {\n        top: 72px;\n        left: 40px;\n      }\n      .lds-roller div:nth-child(5) {\n        animation-delay: -0.18s;\n      }\n      .lds-roller div:nth-child(5):after {\n        top: 70.90963px;\n        left: 31.71779px;\n      }\n      .lds-roller div:nth-child(6) {\n        animation-delay: -0.216s;\n      }\n      .lds-roller div:nth-child(6):after {\n        top: 67.71281px;\n        left: 24px;\n      }\n      .lds-roller div:nth-child(7) {\n        animation-delay: -0.252s;\n      }\n      .lds-roller div:nth-child(7):after {\n        top: 62.62742px;\n        left: 17.37258px;\n      }\n      .lds-roller div:nth-child(8) {\n        animation-delay: -0.288s;\n      }\n      .lds-roller div:nth-child(8):after {\n        top: 56px;\n        left: 12.28719px;\n      }\n      @keyframes lds-roller {\n        0% {\n          transform: rotate(0deg);\n        }\n        100% {\n          transform: rotate(360deg);\n        }\n      }\n    }\n\n    .hide-modal-loader {\n      opacity: 0;\n      pointer-events: none;\n    }\n  }\n  .result {\n    // background-color: rgba(243, 243, 243, 1);\n    transition: all 0.3s ease;\n    padding: 20px 30px;\n\n    .result-wrapper {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 20px;\n      .item {\n        border: 1px solid rgba(243, 243, 243, 1);\n        min-width: 185px;\n        padding: 0px 20px;\n        height: 100px;\n        background-color: rgba(240, 240, 240, 0.589);\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        border-radius: 20px;\n\n        gap: 12px;\n        span {\n          display: flex;\n          font-size: 14px;\n          font-weight: 600;\n          color: #8c87a8;\n        }\n        h3 {\n          display: flex;\n          font-size: 20px;\n          font-weight: 600;\n          color: #624de3;\n        }\n      }\n    }\n    .totel {\n      padding: 20px;\n      border-radius: 20px;\n      background-color: rgba(240, 240, 240, 0.589);\n      p {\n        font-size: 18px;\n        font-weight: 500;\n        color: rgba(19, 17, 17, 1);\n      }\n    }\n  }\n}\n",".finance-dashboard {\n  .chart-wrapper {\n    width: 100%;\n    overflow: hidden;\n  }\n  .page-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .ant-select {\n      width: 170px;\n      border-radius: 20px !important;\n      height: 40px;\n      .ant-select-selector {\n        border-radius: 20px;\n        border: 1px solid $secondary;\n      }\n    }\n  }\n}\n\n.twin_inputs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  .currency_input {\n    .ant-select {\n      width: 100% !important;\n    }\n  }\n}\n.balance_wrapper {\n  margin-top: 20px;\n\n  span {\n    color: #1953e9;\n  }\n}\n\n.down_icon_wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 10px;\n  padding-bottom: 20px;\n  .down_icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: $secondary;\n    color: $light;\n  }\n}\n\n.balance-chart-box {\n  .page-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .action_side {\n      display: flex;\n      gap: 24px;\n      .ant-btn {\n        display: flex;\n        border-radius: 20px;\n        background-color: transparent;\n        color: $dark;\n        border: 1px solid $secondary;\n      }\n\n      .ant-picker {\n        color: $dark;\n        border-radius: 20px;\n        border: 1px solid $secondary;\n        color: $dark;\n        .ant-picker-input {\n          input {\n            &::placeholder {\n              color: $dark;\n            }\n          }\n        }\n        .ant-picker-suffix {\n          color: $dark !important;\n        }\n      }\n    }\n  }\n  .chart-wrapper {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* Creates 3 equal columns */\n    gap: 50px;\n    .chart-area {\n      display: flex;\n      align-items: center;\n\n      .apexcharts-legend-text {\n        text-transform: capitalize;\n        transition: color 0.3s ease;\n      }\n\n      .label-lists {\n        list-style-type: none;\n        text-transform: capitalize;\n      }\n    }\n  }\n}\n",".expenses {\n  .page-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.designed-sum {\n  padding: 21px;\n  border-radius: 8px;\n  background-color: #739bff;\n  font-size: 14px;\n  font-weight: 400;\n  color: $light;\n}\n.expense-type-raw {\n  font-weight: 600 !important;\n}\n.method-raw {\n  text-transform: uppercase;\n}\n\n.expense-comment {\n  height: 40px;\n}\n\n.date-filter {\n  border: 1px solid $secondary;\n  border-radius: 20px;\n  .ant-picker-input {\n    width: 90px;\n  }\n  .ant-picker-suffix {\n    color: $dark !important;\n  }\n}\n\n.single-input-item-payment {\n  display: flex;\n}\n\n.payment-wrapper {\n  .currency {\n    .ant-select {\n      height: 44px;\n    }\n    label {\n      opacity: 0; /* Set the desired opacity value */\n      pointer-events: none;\n\n      .ant-form-item-required::before {\n        content: \"ppp\";\n        color: #fff !important;\n      }\n    }\n  }\n}\n\n.message-text-wrapper {\n  border: 1px solid #a1a3ab;\n  border-radius: 6px;\n  padding: 14px;\n}\n\n.total-salary{\n  .amount-wrapper{\n    padding: 10px;\n    border-radius: 8px;\n    background-color: #739BFF;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    span{\n      display: flex;\n    }\n  }\n}",".canban {\n  padding: 0 30px 30px 30px;\n  height: calc(100% - 160px);\n}\n\n.sales-performance-box {\n  box-shadow: 0px 2px 6px 0px #0d0a2c14;\n  margin: 30px;\n  margin-bottom: 40px;\n  border-radius: 20px;\n  padding: 30px;\n  .title-wrapper {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 30px;\n  }\n}\n\n.canban_list_wrapper {\n  height: 100%;\n  .canban_list {\n    list-style: none;\n    display: flex;\n    gap: 20px;\n    height: 100%;\n    width: 100%;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n    overflow: auto;\n    .canban_list_item {\n      transition: all 0.3s ease;\n      background-color: #fff;\n      min-height: 500px;\n      height: 100%;\n      transition: all 0.3s ease;\n      position: relative;\n      overflow-y: auto;\n      min-width: 240px;\n      &::-webkit-scrollbar {\n        display: none;\n      }\n      .column_info {\n        margin-bottom: 10px;\n        background-color: #fff;\n        z-index: 999;\n        position: sticky;\n        top: 0;\n        .column_name {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          padding-bottom: 10px;\n          border-bottom: 1px solid #a4a4a4;\n          margin-bottom: 10px;\n          h3 {\n            font-weight: 600;\n            font-size: 14px;\n          }\n          span {\n            font-size: 12px;\n            font-weight: 400;\n            color: #595959;\n            padding: 5px 20px;\n            border-radius: 10px;\n            border: 1px solid #d9d9d9;\n          }\n        }\n        .add_card_btn {\n          border: 1px solid #a4a4a4;\n          border-radius: 5px;\n          font-size: 14px;\n          font-weight: 500;\n          color: #a4a4a4;\n          padding: 7px 70px;\n          outline: none;\n          cursor: pointer;\n          background-color: transparent;\n          width: 100%;\n        }\n      }\n\n      .canban_column {\n        list-style: none;\n        height: fit-content;\n        min-height: calc(100% - 94px);\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        .canban_column_item {\n          padding: 10px 8px;\n          box-shadow: 0px 3px 9px 0px #ff5c0024;\n\n          width: 239px;\n          height: 138px;\n          border: 1px solid #ff5c00;\n          border-radius: 5px;\n          &:hover {\n            cursor: grab;\n          }\n\n          .action {\n            display: flex;\n            gap: 10px;\n            justify-content: end;\n            margin-bottom: 10px;\n\n            .trash {\n              color: #a30d11 !important;\n              width: 14px !important;\n              height: 14px !important;\n              cursor: pointer;\n            }\n            .edit {\n              color: #624de3 !important;\n              width: 14px !important;\n              height: 14px !important;\n              cursor: pointer;\n            }\n          }\n          .info_raw {\n            display: flex;\n            margin-bottom: 8px;\n            gap: 8px;\n            strong {\n              cursor: pointer !important;\n            }\n            span {\n              font-weight: 400;\n              font-size: 12px;\n              color: #888888;\n              width: 70px;\n            }\n            p {\n              font-size: 12px;\n              font-weight: 400;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.dragging-overlay {\n  padding: 10px 8px;\n  box-shadow: 0px 3px 9px 0px #ff5c0024;\n  background-color: #fff;\n  transition: all 0.3s ease;\n  list-style: none;\n  width: 239px;\n  height: 138px;\n  border: 1px solid #000000;\n  border-radius: 5px;\n  &:hover {\n    cursor: grabbing;\n  }\n  .action {\n    display: flex;\n    gap: 10px;\n    justify-content: end;\n    margin-bottom: 10px;\n\n    .trash {\n      color: #a30d11 !important;\n      width: 14px !important;\n      height: 14px !important;\n      cursor: pointer;\n    }\n    .edit {\n      color: #624de3 !important;\n      width: 14px !important;\n      height: 14px !important;\n      cursor: pointer;\n    }\n  }\n\n  .info_raw {\n    display: flex;\n    margin-bottom: 8px;\n    gap: 8px;\n\n    span {\n      font-weight: 400;\n      font-size: 12px;\n      color: #888888;\n      width: 70px;\n    }\n    p {\n      font-size: 12px;\n      font-weight: 400;\n    }\n  }\n}\n\n.empty-column-placeholder {\n  text-align: center;\n  padding-top: 30px;\n}\n\n////////////////////////////\n\n.kanban-board {\n  display: flex;\n  justify-content: space-around;\n  padding: 20px;\n  height: 100vh;\n}\n\n.column {\n  background-color: #e2e4e6;\n  border-radius: 8px;\n  width: 30%;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.column-title {\n  font-size: 18px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.task-list {\n  background-color: #f4f5f7;\n  border-radius: 4px;\n  flex-grow: 1;\n  min-height: 100px;\n  padding: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.task {\n  background-color: #ffffff;\n  border-radius: 2px;\n  padding: 8px;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);\n  transition: background-color 0.2s ease;\n}\n\n.canban_mobile {\n  display: none;\n}\n\n.select_status {\n  margin-top: 20px;\n  h3 {\n    margin-bottom: 10px;\n    font-size: 16px;\n    font-weight: 500;\n  }\n  ul {\n    list-style: none;\n    display: flex;\n    gap: 40px;\n    li {\n      padding: 4px 10px;\n      border-radius: 4px;\n      font-weight: 600;\n      font-size: 12px;\n      cursor: pointer;\n    }\n  }\n}\n\n.textarea_input {\n  width: 100%;\n  .ant-form-item-required {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    color: #131111;\n  }\n  .single-input-item {\n    .ant-input {\n      height: 100px;\n    }\n  }\n}\n\n.card_item {\n  padding: 28px;\n  .column_name {\n    padding: 4px 10px;\n    width: fit-content;\n    border-radius: 4px;\n    font-size: 12px;\n    margin-bottom: 6px;\n  }\n  h2 {\n    font-size: 32px;\n    font-weight: 500;\n  }\n  .date {\n    font-size: 14px;\n    font-weight: 400;\n    color: #404040;\n    margin-bottom: 20px;\n  }\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    display: flex;\n    margin-bottom: 10px;\n    p {\n      color: #888888;\n      font-size: 12px;\n      font-weight: 400;\n      width: 100px;\n    }\n  }\n  h4 {\n    margin-top: 20px;\n  }\n  .description {\n    border: 1px solid #a1a3ab;\n    border-radius: 6px;\n    padding: 14px;\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: 10px;\n  }\n  .agent {\n    width: 100%;\n    padding-top: 14px;\n    border-top: 1px solid #dee2e6;\n    margin-top: 20px;\n  }\n}\n\n@media (max-width: 700px) {\n  .canban {\n    padding: 0 30px 30px 30px;\n    height: calc(100% - 160px);\n  }\n\n  .ant-modal-confirm {\n    .ant-modal-content {\n      width: 310px !important;\n    }\n  }\n\n  .expenses-modal {\n    display: flex;\n    justify-content: center;\n    max-width: 322px !important;\n    .ant-modal-content {\n      padding: 15px !important;\n    }\n    .form-wrapper {\n      overflow: auto;\n      max-width: 322px;\n      max-height: calc(100dvh - 150px);\n\n      ul {\n        overflow: auto;\n        &::-webkit-scrollbar {\n          display: none;\n        }\n      }\n      .expenses-input-wrapper {\n        display: grid;\n        grid-template-columns: 1fr;\n        .salary {\n          .salary-inner {\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  .sales {\n    .page-title {\n      padding: 10px;\n      .title-wrapper {\n        h1 {\n          font-size: 18px;\n        }\n        p {\n          font-size: 14px;\n        }\n      }\n    }\n    .canban_desktop {\n      display: none;\n    }\n  }\n\n  .ant-select-item-option-content {\n    span {\n      color: #000 !important;\n    }\n  }\n  .mobile_modal {\n    .ant-modal-content {\n      width: 322px !important;\n    }\n  }\n\n  .canban_mobile {\n    display: block;\n    width: 100%;\n    padding-bottom: 50px;\n\n    .select_status {\n      .ant-select-selector {\n        border-radius: 10px;\n        border: none !important;\n      }\n      .ant-select {\n        width: 100%;\n        border-radius: 10px;\n        height: 46px;\n        // border-color: #acacac !important;\n        border: 1px solid #acacac;\n      }\n    }\n\n    .add_card_btn {\n      padding-top: 16px;\n      .add_btn_wrapper {\n        border: 1px solid #a4a4a4;\n        border-radius: 5px;\n        font-size: 14px;\n        font-weight: 500;\n        color: #a4a4a4;\n        padding: 7px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 5px;\n      }\n    }\n    .canban_items {\n      ul {\n        list-style: none;\n        padding-top: 16px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        li {\n          .item_wrapper {\n            border-radius: 5px;\n            padding: 10px;\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            box-shadow: 0px 3px 9px 0px #ff5c0024;\n\n            .action {\n              position: absolute;\n              right: 10px;\n              top: 10px;\n              display: flex;\n              gap: 5px;\n              .edit {\n                color: #624de3 !important;\n              }\n              .trash {\n                color: #a30d11 !important;\n              }\n            }\n\n            .info_raw {\n              display: flex;\n\n              span {\n                font-size: 12px;\n                color: #888888;\n                font-weight: 400;\n                min-width: 80px;\n              }\n              p {\n                font-size: 12px;\n                font-weight: 400;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .content {\n    padding: 10px;\n    background-color: #fff;\n  }\n\n  .sales-performance-box {\n    box-shadow: none;\n    margin: 0px;\n    margin-bottom: 40px;\n    border-radius: 20px;\n    padding: 10px;\n    .title-wrapper {\n      display: flex;\n      justify-content: space-between;\n      padding-bottom: 30px;\n      flex-direction: column;\n      gap: 16px;\n      * {\n        display: none;\n      }\n      h2 {\n        display: flex;\n        font-size: 14px;\n      }\n    }\n  }\n}\n",".task_playground {\n  border-radius: 16px;\n  padding: 30px 20px;\n  background-color: $light;\n  min-height: calc(100dvh - 120px);\n  .page-heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .page-title {\n      margin-bottom: 22px;\n      h1 {\n        font-size: 32px;\n        font-weight: 600;\n        margin-bottom: 12px;\n      }\n      p {\n        font-weight: 400;\n        font-size: 20px;\n        color: $secondary_gray;\n      }\n    }\n    .upper-section {\n      .ant-btn {\n        border-radius: 20px;\n        background-color: $secondary;\n      }\n    }\n  }\n\n  .playground_list {\n    list-style: none;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 24px;\n    .list_item {\n      padding: 16px;\n      border: 1px solid #ededed;\n      border-radius: 12px;\n      background-color: #f6f6f6;\n      height: 150px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      .up_side {\n        display: flex;\n        justify-content: space-between;\n        .title {\n          font-size: 24px;\n          font-weight: 600;\n          color: $secondary;\n          cursor: pointer;\n          max-width: 290px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n        .icon {\n          cursor: pointer;\n        }\n      }\n      .low_side {\n        padding-top: 10px;\n        border-top: 1px solid #ededed;\n        .author {\n          display: flex;\n          span {\n            display: flex;\n            margin-right: 5px;\n          }\n          p {\n            display: flex;\n          }\n        }\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n      }\n    }\n  }\n}\n\n.popover_content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  span {\n    display: flex;\n    width: 100px;\n    cursor: pointer;\n    p {\n      font-size: 16px;\n      font-weight: 500;\n      color: #686666;\n    }\n    .icon {\n      width: 20px;\n      height: 20px;\n      margin-right: 8px;\n      color: #686666 !important;\n    }\n  }\n}\n\n.canban_page_wrapper {\n  height: calc(100dvh - 120px) !important;\n  overflow: hidden;\n}\n\n.priority_high {\n  color: #dd2f2f !important;\n}\n.trello_title_wrapper {\n  display: flex;\n  flex-direction: column;\n}\n.trello_back_btn {\n  display: flex;\n  align-items: center;\n  padding-bottom: 20px;\n  width: 100%;\n  * {\n    color: $secondary_gray !important;\n  }\n  div {\n    display: flex;\n    align-items: center;\n    .icon {\n      transform: rotateZ(90deg);\n    }\n  }\n}\n\n.priority_medium {\n  color: #ff9900 !important;\n}\n.priority_low {\n  color: #1953e9 !important;\n}\n\n.trello_column_item {\n  border: 1px solid #a4a4a4;\n  padding: 16px;\n  border-radius: 10px;\n  &:hover {\n    cursor: grab;\n  }\n\n  .item_wrapper {\n    .prpject_title {\n      h2 {\n        font-size: 16px;\n        font-weight: 600;\n        max-width: 205px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: fit-content;\n      }\n    }\n    .priority {\n      display: flex;\n      align-items: center;\n      margin-top: 4px;\n      gap: 20px;\n      margin-bottom: 12px;\n      justify-content: space-between;\n      span {\n        display: block;\n        font-size: 14px;\n        color: #54577a;\n        max-width: 160px !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .icon {\n        min-width: 20px;\n        min-height: 20px;\n        max-width: 20px;\n        max-height: 20px;\n      }\n    }\n    .date {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 12px;\n      .date_wrapper {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        .icon {\n          width: 22px;\n          height: 22px;\n          color: #00c853 !important;\n        }\n      }\n\n      .action {\n        cursor: pointer;\n      }\n    }\n    .members {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      .mine {\n        font-size: 10px;\n        font-weight: 500;\n        padding: 2px 5px;\n        border-radius: 4px;\n        background-color: #edf8fe;\n        color: #517a9a;\n        text-transform: uppercase;\n        box-sizing: border-box;\n        border: 1px solid #32b4fd;\n      }\n    }\n    .creators {\n      cursor: pointer !important;\n      width: fit-content;\n    }\n  }\n}\n.trello_btn_wrapper {\n  height: 70vh;\n  align-items: center;\n  display: flex;\n  padding-left: 20px;\n}\n.add_column_trello {\n  display: flex;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  background-color: $secondary;\n  cursor: pointer;\n  * {\n    color: $light;\n  }\n}\n\n.status {\n  .icon {\n    cursor: pointer;\n  }\n}\n.page_title_wrapper_trello {\n  width: 100%;\n}\n.upper_section_trello {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  .add-btn {\n    .ant-btn {\n      background-color: $secondary !important;\n      border-radius: 20px !important;\n    }\n  }\n}\n\n.colors_for_playground {\n  display: flex;\n  gap: 14px;\n  justify-content: space-between;\n\n  span {\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n}\n.color_label {\n  font-size: 14px;\n  display: flex;\n  margin-bottom: 14px;\n}\n.dragging-overlay-trello {\n  list-style: none;\n  background-color: #fff;\n\n  .item_wrapper {\n    &:hover {\n      cursor: grabbing;\n    }\n    .prpject_title {\n      h2 {\n        font-size: 16px;\n        font-weight: 600;\n      }\n    }\n    .priority {\n      display: flex;\n      align-items: center;\n      margin-top: 4px;\n      gap: 20px;\n      margin-bottom: 12px;\n      span {\n        font-size: 14px;\n        color: #54577a;\n      }\n      .icon {\n        width: 20px;\n        height: 20px;\n      }\n    }\n    .date {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 12px;\n      .date_wrapper {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        .icon {\n          width: 22px;\n          height: 22px;\n        }\n      }\n      .action {\n        .icon {\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n\n.file_upload_trello {\n  .ant-upload-list {\n    display: flex;\n    flex-wrap: wrap;\n    .ant-upload-list-item {\n      margin-right: 10px;\n    }\n  }\n}\n\n.multiple_select_trello {\n  min-height: fit-content;\n  .ant-select-selector {\n    min-height: 44px;\n  }\n  .ant-select {\n    position: relative;\n\n    .ant-select-selection-item {\n      min-height: 40px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      background-color: #e3e9f9;\n      .ant-select-selection-item-content {\n        font-size: 14px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n.small-modal {\n  position: relative;\n  z-index: 9999999;\n}\n\n.ant-popover {\n  z-index: 1000;\n}\n\n.task_create_modal_wrapper {\n  padding: 30px;\n  height: 100%;\n  .single-input-item {\n    position: relative;\n    .ant-row {\n      align-items: start;\n      width: 100%;\n      .ant-col {\n        width: 100%;\n      }\n    }\n    label {\n      font-size: 16px;\n      font-weight: 500;\n      color: #131111;\n      text-align: start;\n      display: flex;\n    }\n    input {\n      height: 44px;\n      width: 100%;\n    }\n\n    .ant-select {\n      height: 44px !important;\n      position: relative;\n    }\n    .ant-picker {\n      height: 44px !important;\n    }\n    .ant-form-item {\n      margin-bottom: 0;\n    }\n\n    .ant-form-item-has-error {\n      .PhoneInput {\n        input {\n          border-color: #ff4d4f;\n        }\n      }\n    }\n\n    .PhoneInput {\n      border: none !important;\n      input {\n        border-radius: 6px;\n        outline: none;\n        border: 1px solid #d9d9d9;\n        padding: 4px 11px;\n        font-size: 14px;\n        transition: all 0.3s ease;\n        &::placeholder {\n          color: #bfbfbf;\n        }\n        &:focus {\n          border-color: #1677ff;\n          box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);\n        }\n      }\n      .PhoneInputCountry {\n        display: none;\n      }\n      .PhoneInput--focus {\n        border: 1px solid none !important;\n      }\n    }\n  }\n}\n\n\n.w-full {\n  width: 100%;\n}\n\n.flex-row {\n  display: flex;\n  gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
